import { GoogleMap, withGoogleMap, withScriptjs } from "react-google-maps"
import * as React from 'react';
import { compose, withProps } from "recompose";
import Marker from 'react-google-maps/lib/components/Marker';
import googleMaps from '../../api/googleMaps';
import DirectionsRenderer from 'react-google-maps/lib/components/DirectionsRenderer';
import { Button, CircularProgress, Grid, IconButton, MenuItem, Select, Dialog, DialogTitle, DialogContent, DialogActions, Tabs, Tab, LinearProgress } from "@material-ui/core";
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';



import StandaloneSearchBox from 'react-google-maps/lib/components/places/StandaloneSearchBox';
import MoneyLabel from '../MoneyLabel';
import NumberFormat from 'react-number-format';
import DirectionsResult = google.maps.DirectionsResult;
import PlaceResult = google.maps.places.PlaceResult;
import DirectionsLeg = google.maps.DirectionsLeg;
import DirectionsRoute = google.maps.DirectionsRoute;
import LatLngBounds = google.maps.LatLngBounds;
import { ConfigData } from "../../config";
import { getApi } from '../../api/ApiProvider';
import { BranchData } from '../BranchSelector'


import { Client, Driver, Race, Ruta, RutasData } from "src/api/model";
import { RaceActions } from "src/store/race/race-actions";
import { SortDirection } from "@material-ui/core/TableCell";
import { ColumnDefinition } from "../AsyncTable";
import DeleteIcon from "@material-ui/icons/Delete";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { format } from "date-fns";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

export interface Vehicle {
    id: number;
    placa: string;
    marca: string;
    modelo: string;
    capacidadCajas: number;
    conductor?: Driver;
    estado: 'ACTIVO' | 'INACTIVO' | 'MANTENIMIENTO';
}




export class Dot {
    lat: number;
    lng: number;

    constructor(latitude: number, longitude: number) {
        this.lat = latitude;
        this.lng = longitude;
    }

}

interface VisitsDetail {
    id?: number;
    client: Client | undefined;
    location: Dot;
    visitDateTime: string | undefined;
    observations?: string;
    order?: number;
    street1?: string;
    type: string;
    amount: number;
    nroComprobante?: number;
    tipoComprobante?: string;
}

export interface RouteData {

    origin?: Dot;
    originStreet?: string;
    destiny?: Dot;
    destinyStreet?: string;

    distance?: number;
    price?: number;
    duration?: string;
    fullData?: DirectionsResult;
    route?: DirectionsRoute;
    leg?: DirectionsLeg;
    searchBounds?: LatLngBounds;

    // Client document
    clientDocument?: string;
    clientLocations?: LocationData[];
    selectedClientLocationId?: string;
    selectedClientLocation?: any;

    // Branch data used as origin 
    selectedBranch?: BranchData;
    branchList?: BranchData[];
    races?: Race[]
    branches?: any[]
    selectedDriver?: any;
    drivers?: Driver[];
    selectedType?: string;

    visitsDetail?: any[];
    selectedClient?: Client | undefined;
    selectedLoc?: any;
    items?: any[];
    observation?: string;
}

export interface PlanificacionSelectorProps {
    data?: RouteData;
    config: ConfigData;
    onNewData: (data: RouteData) => void;
    sendData: (data: any) => void;
    notification?: any;
    onCreateBranches?: (branches: any[]) => Promise<void>; // Callback para crear sucursales
    onCreateDrivers?: (drivers: any[]) => Promise<void>; // Callback para crear choferes
    onCancelBranchCreation?: () => void; // Callback para cancelar creación de sucursales
    driverActions?: { actions: any; notification: any }; // Actions para drivers
}

type MarkerType = 'origin' | 'destiny';

interface PlanificacionSelectorState {

    data: RouteData;
    line?: string;
    center: Dot;

    // new design clien data
    filter: string,
    filterLoc: string,
    filterDir: string,
    pageNum: number,
    pageSize: number,
    locations?: any[];
    totalItems: number;
    isDialogOpenLoc: boolean;
    isDialogOpenReparto: boolean;
    isDialogOpen: boolean;
    isDialogHojaOpen: boolean;
    openSearch: boolean;
    actions: RaceActions;
    selectedValue: string,

    table: {
        data: any;
        sortBy: string;
        sortDirection: SortDirection;
        columnData: ColumnDefinition[];
    };

    confirmarOrdenFlag: boolean;
    visitsDetail: any[];
    setPrice: number;
    limit: number;

    pageNumRace: number;
    pageSizeRace: number;
    totalItemsRace: number;

    dataRace: any;
    filterRace: string;
    dateFromRace: string;
    dateToRace: string;
    type: string;
    driverId: number;
    branchId: number;
    branchDestinyId: number;
    selectedState: string;

    // Form state for CSV upload
    vehicleCapacityBoxes: string;
    numVehicles: string;
    depotIndex: number;
    serviceTime: number;
    demandUnit: string;
    capacityUnit: string;
    boxVolumeM3: number;
    csvLocationsFile: File | null;
    csvDriversFile: File | null;
    csvFleetFile: File | null;
    isUploading: boolean;
    selectedBranches: number[];
    selectedDrivers: number[];
    branchDemands: { [branchId: number]: number }; // Demandas personalizadas por sucursal
    driverCapacities: { [driverId: number]: number }; // Capacidades personalizadas por conductor

    // Progress tracking for race creation
    isCreatingRaces: boolean;
    racesCreationProgress: number;
    totalRacesToCreate: number;
    racesCreated: number;

    // Progress tracking for branch creation from CSV
    isCreatingBranches: boolean;
    branchesCreationProgress: number;
    totalBranchesToCreate: number;
    branchesCreated: number;
    currentBatch: number;
    totalBatches: number;
    isCancellingBranches: boolean;
    retryAttempts: number;
    maxRetries: number;
    creationSummary: { success: number; errors: number; retries: number } | null;

    // Progress tracking for driver creation from CSV
    isCreatingDrivers: boolean;
    driversCreationProgress: number;
    totalDriversToCreate: number;
    driversCreated: number;
    currentDriverBatch: number;
    totalDriverBatches: number;
    isCancellingDrivers: boolean;
    driverRetryAttempts: number;
    driverMaxRetries: number;
    driverCreationSummary: { success: number; errors: number; retries: number } | null;

    // Routes data
    routesData: RutasData;
    selectedRouteId: number | null;
    showRoutesOnMap: boolean;
    routeDirections: { [key: number]: any };
    showMarkersOnly: boolean; // Solo mostrar marcadores sin rutas completas
    maxVisibleRoutes: number; // Límite de rutas visibles simultáneamente

    // Excluded nodes data
    excludedNodes: any[];
    excludedNodesExpanded: boolean;
    // Modal state for route details
    showRouteDetailsModal: boolean;
    selectedRouteForDetails: Ruta | null;

    // Tab state
    selectedTab: number;
}

interface MapProps {

    zoom: number;
    center: Dot;
    origin?: Dot;
    destiny?: any;
    directions: any;

    // Routes data
    routesData: RutasData;
    selectedRouteId?: number | null;
    showRoutesOnMap?: boolean;
    routeDirections: { [key: number]: any };
    onRouteDirectionsChange: (newRouteDirections: { [key: number]: any }) => void;
    maxVisibleRoutes?: number;
    showMarkersOnly?: boolean;

    handleOnClick(e: google.maps.MouseEvent | google.maps.IconMouseEvent): void;

    handleDragEnd(whichOne: string, index?: number, type?: string): (e: google.maps.MouseEvent) => void;

}

export interface LocationData {
    id: number;
    lat: number;
    lng: number;

    street1: string;
    client: {
        user: { name: string, email: string }
        phone: string;

    };

}

// Variable para controlar las solicitudes en progreso a la API de Directions
let directionsRequestsInProgress = 0;
const MAX_CONCURRENT_DIRECTIONS_REQUESTS = 5; // Aumentado de 2 a 5 para mejor rendimiento

const RouteMap: React.SFC<MapProps> = (props: MapProps) => {
    const { center, zoom, destiny, handleDragEnd, directions, routesData, selectedRouteId, showRoutesOnMap, routeDirections, onRouteDirectionsChange, maxVisibleRoutes = 3, showMarkersOnly = false } = props;

    // Límite de marcadores para evitar sobrecarga del mapa
    const MAX_MARKERS_PER_ROUTE = 50;

    // Función para obtener el color de cada ruta (mismo color para marcadores y polyline)
    const getRouteColor = (vehiculoId: number): string => {
        const colors = [
            // Primera fila - Colores primarios y básicos
            '#FF0000', // 1. Rojo
            '#00FF00', // 2. Verde lima
            '#0000FF', // 3. Azul
            '#FFFF00', // 4. Amarillo
            '#FF00FF', // 5. Magenta
            '#00FFFF', // 6. Cyan
            '#FF8000', // 7. Naranja
            '#8000FF', // 8. Púrpura
            '#00FF80', // 9. Verde menta
            '#FF0080', // 10. Rosa

            // Segunda fila - Colores complementarios y variaciones
            '#FF4500', // 11. Rojo-naranja (OrangeRed)
            '#32CD32', // 12. Verde lima (LimeGreen)
            '#4169E1', // 13. Azul real (RoyalBlue)
            '#FFD700', // 14. Oro (Gold)
            '#DC143C', // 15. Carmesí (Crimson)
            '#00CED1', // 16. Turquesa oscuro (DarkTurquoise)
            '#FF1493', // 17. Rosa intenso (DeepPink)
            '#9370DB', // 18. Púrpura medio (MediumPurple)
            '#20B2AA', // 19. Verde mar claro (LightSeaGreen)
            '#FF6347', // 20. Tomate (Tomato)
        ];
        return colors[(vehiculoId - 1) % colors.length];
    };

    return (
        <GoogleMap defaultZoom={zoom} center={center} >
            {/* Existing markers for visits */}
            {destiny &&
                destiny.length > 0 &&
                destiny.map((item: VisitsDetail, index: number) => (
                    <Marker
                        draggable
                        onDragEnd={handleDragEnd("destiny", index, item.order && item.order === 1 ? 'O' : 'R')}
                        position={item.location}
                        label={{
                            text: item.order && item.order === 1 ? 'O' : 'R' + item.order,
                            color: item.order && item.order === 1 ? "green" : "red",
                            fontSize: "20px",
                            fontWeight: "bold"
                        }}
                        key={index}
                    />
                ))}

            {/* Routes markers and directions */}
            {routesData && routesData.slice(0, maxVisibleRoutes).map((route: Ruta, routeIndex: number) => {
                // Filtrar por ruta seleccionada si existe
                if (selectedRouteId && route.vehiculoId !== selectedRouteId) { return null; };

                // Limitar cantidad de marcadores por ruta para mejor rendimiento
                const paradasLimitadas = route.paradas.slice(0, MAX_MARKERS_PER_ROUTE);
                const paradasOcultas = route.paradas.length - paradasLimitadas.length;

                // Obtener color único para esta ruta
                const routeColor = getRouteColor(route.vehiculoId);

                return (
                    <React.Fragment key={route.vehiculoId}>
                        {/* Route markers */}
                        {paradasLimitadas.map((parada: any, index: number) => {
                            const isDepot = parada.tipoParada.includes('Depósito');

                            return (
                                <Marker
                                    key={`${route.vehiculoId}-${index}`}
                                    position={{ lat: parada.coordenadas[1], lng: parada.coordenadas[0] }}
                                    icon={{
                                        path: google.maps.SymbolPath.CIRCLE,
                                        scale: isDepot ? 12 : 10,
                                        fillColor: isDepot ? '#FFD700' : routeColor, // Dorado para depósitos, color de ruta para paradas
                                        fillOpacity: isDepot ? 1.0 : 0.9,
                                        strokeColor: '#FFFFFF',
                                        strokeWeight: 2,
                                    }}
                                    label={{
                                        text: isDepot ? '🏁' : `${index}`,
                                        color: 'white',
                                        fontSize: isDepot ? '20px' : '14px',
                                        fontWeight: 'bold'
                                    }}
                                    title={`${parada.nombreSucursal} - ${parada.horaLlegada}${paradasOcultas > 0 && index === paradasLimitadas.length - 1 ? ` (+${paradasOcultas} más)` : ''}`}
                                />
                            );
                        })}

                        {/* Route directions - using Google Maps API directly */}
                        {!showMarkersOnly && showRoutesOnMap && (() => {
                            // Only calculate if we don't have directions for this route yet
                            if (!routeDirections || !routeDirections.hasOwnProperty(route.vehiculoId)) {
                                // Capture route data immediately to avoid closure issues
                                const currentVehicleId = route.vehiculoId;
                                const currentParadas = [...route.paradas]; // Create a copy to avoid reference issues

                                // Crear clave única para cache basada en las coordenadas
                                const cacheKey = `route_${currentVehicleId}_${currentParadas.map(p => `${p.coordenadas[0]}_${p.coordenadas[1]}`).join('_')}`;

                                // Intentar obtener de cache primero
                                try {
                                    const cachedRoute = localStorage.getItem(cacheKey);
                                    if (cachedRoute) {
                                        const parsedCache = JSON.parse(cachedRoute);
                                        const newRouteDirections = { ...(routeDirections || {}) };

                                        // Manejar formato antiguo (sin timestamp) y nuevo (con timestamp)
                                        if (parsedCache.timestamp && parsedCache.data) {
                                            // Formato nuevo con timestamp
                                            newRouteDirections[currentVehicleId] = parsedCache.data;
                                            console.info(`✅ Ruta ${currentVehicleId}: Cargada desde cache (${new Date(parsedCache.timestamp).toLocaleString()})`);
                                        } else {
                                            // Formato antiguo sin timestamp
                                            newRouteDirections[currentVehicleId] = parsedCache;
                                            console.info(`✅ Ruta ${currentVehicleId}: Cargada desde cache (formato antiguo)`);
                                        }

                                        onRouteDirectionsChange(newRouteDirections);
                                        return null; // Usar cache y salir
                                    }
                                } catch (e) {
                                    // Si falla el cache, continuar con la llamada a la API
                                    console.warn('Error leyendo cache, recalculando ruta:', e);
                                }

                                // Verificar si ya hay demasiadas solicitudes en progreso (throttling)
                                if (directionsRequestsInProgress >= MAX_CONCURRENT_DIRECTIONS_REQUESTS) {
                                    return null; // Esperar a que se completen las solicitudes actuales
                                }

                                // Calculate route using Google Maps Directions API
                                directionsRequestsInProgress++;
                                console.info(`🔄 Ruta ${currentVehicleId}: Calculando desde Google Maps API (${directionsRequestsInProgress}/${MAX_CONCURRENT_DIRECTIONS_REQUESTS} en progreso)...`);
                                const directionsService = new google.maps.DirectionsService();

                                const waypoints = currentParadas.slice(1, -1).map((parada: any) => ({
                                    location: new google.maps.LatLng(parada.coordenadas[1], parada.coordenadas[0]),
                                    stopover: true
                                }));

                                const request = {
                                    origin: new google.maps.LatLng(currentParadas[0].coordenadas[1], currentParadas[0].coordenadas[0]),
                                    destination: new google.maps.LatLng(currentParadas[currentParadas.length - 1].coordenadas[1], currentParadas[currentParadas.length - 1].coordenadas[0]),
                                    waypoints: waypoints,
                                    travelMode: google.maps.TravelMode.DRIVING,
                                    optimizeWaypoints: false
                                };

                                directionsService.route(request, (result: any, status: any) => {
                                    directionsRequestsInProgress--; // Decrementar contador

                                    if (status === google.maps.DirectionsStatus.OK && result) {
                                        console.info(`✅ Ruta ${currentVehicleId}: Calculada exitosamente. Guardando en cache...`);
                                        const newRouteDirections = { ...(routeDirections || {}) };
                                        newRouteDirections[currentVehicleId] = result; // Use captured vehicleId
                                        onRouteDirectionsChange(newRouteDirections);

                                        // Guardar en cache para futuros usos con timestamp
                                        try {
                                            const cacheData = {
                                                timestamp: Date.now(),
                                                data: result
                                            };
                                            localStorage.setItem(cacheKey, JSON.stringify(cacheData));
                                        } catch (e) {
                                            // Si falla guardar en cache (localStorage lleno), intentar limpiar cache antiguo
                                            if (e.name === 'QuotaExceededError') {
                                                console.warn('localStorage lleno, limpiando cache antiguo...');
                                                clearOldRoutesCache(7); // Limpiar rutas de más de 7 días
                                                try {
                                                    // Intentar guardar nuevamente
                                                    const cacheData = {
                                                        timestamp: Date.now(),
                                                        data: result
                                                    };
                                                    localStorage.setItem(cacheKey, JSON.stringify(cacheData));
                                                } catch (retryError) {
                                                    // Si aún falla, no hacer nada
                                                    console.warn('No se pudo guardar en cache después de limpiar');
                                                }
                                            }
                                        }
                                    } else {
                                        console.warn(`Error calculating route for vehicle ${currentVehicleId}:`, status);
                                    }
                                });
                            }

                            return null; // This is just to trigger the calculation
                        })()}

                        {/* Render directions for this route */}
                        {!showMarkersOnly && showRoutesOnMap && routeDirections && routeDirections[route.vehiculoId] && (
                            <DirectionsRenderer
                                directions={routeDirections[route.vehiculoId]}
                                options={{
                                    suppressMarkers: true,
                                    suppressInfoWindows: true, // Reducir peso
                                    preserveViewport: true, // No cambiar zoom automáticamente
                                    polylineOptions: {
                                        strokeColor: routeColor, // Usar el mismo color que los marcadores
                                        strokeOpacity: 0.7, // Reducido para mejor rendimiento
                                        strokeWeight: 4, // Hacer la línea un poco más visible
                                    }
                                }}
                            />
                        )}
                    </React.Fragment>
                );
            })}

            {directions && (
                <DirectionsRenderer
                    directions={directions}
                    defaultOptions={{
                        suppressMarkers: true,
                        suppressInfoWindows: true,
                        preserveViewport: true
                    }}
                />
            )}
        </GoogleMap>
    );
};

// Función utilitaria para limpiar cache de rutas antiguas (puede ser llamada manualmente)
export const clearRoutesCache = () => {
    try {
        const keys = Object.keys(localStorage);
        let count = 0;
        keys.forEach(key => {
            if (key.startsWith('route_')) {
                localStorage.removeItem(key);
                count++;
            }
        });
        console.info(`Cache de rutas limpiado correctamente. ${count} rutas eliminadas.`);
        return { success: true, count };
    } catch (e) {
        console.error('Error limpiando cache de rutas:', e);
        return { success: false, count: 0 };
    }
};

// Función para obtener información del cache
export const getRoutesCacheInfo = () => {
    try {
        const keys = Object.keys(localStorage);
        const routeKeys = keys.filter(key => key.startsWith('route_'));

        let totalSize = 0;
        routeKeys.forEach(key => {
            const item = localStorage.getItem(key);
            if (item) {
                // Calcular tamaño aproximado en bytes
                totalSize += new Blob([item]).size;
            }
        });

        // Convertir a KB o MB
        const sizeKB = (totalSize / 1024).toFixed(2);
        const sizeMB = (totalSize / (1024 * 1024)).toFixed(2);

        return {
            routeCount: routeKeys.length,
            totalSizeBytes: totalSize,
            totalSizeKB: parseFloat(sizeKB),
            totalSizeMB: parseFloat(sizeMB),
            maxStorage: '5-10 MB (típico)', // localStorage típicamente tiene 5-10MB
        };
    } catch (e) {
        console.error('Error obteniendo información del cache:', e);
        return null;
    }
};

// Función para limpiar cache antiguo (más de X días)
export const clearOldRoutesCache = (daysOld: number = 7) => {
    try {
        const keys = Object.keys(localStorage);
        const now = Date.now();
        const maxAge = daysOld * 24 * 60 * 60 * 1000; // Convertir días a milisegundos

        let count = 0;
        keys.forEach(key => {
            if (key.startsWith('route_')) {
                try {
                    const item = localStorage.getItem(key);
                    if (item) {
                        const data = JSON.parse(item);
                        // Si tiene timestamp y es muy viejo, eliminarlo
                        if (data.timestamp && (now - data.timestamp > maxAge)) {
                            localStorage.removeItem(key);
                            count++;
                        }
                    }
                } catch (parseError) {
                    // Si no se puede parsear, eliminar (corrupto)
                    localStorage.removeItem(key);
                    count++;
                }
            }
        });

        console.info(`Cache antiguo limpiado. ${count} rutas eliminadas (más de ${daysOld} días).`);
        return { success: true, count };
    } catch (e) {
        console.error('Error limpiando cache antiguo:', e);
        return { success: false, count: 0 };
    }
};

const EnhancedMap = compose<MapProps, MapProps>(
    withProps({
        containerElement: <div style={{ height: '400px' }} />,
        mapElement: <div style={{ height: '400px' }} />,
    }),
    withGoogleMap
)(RouteMap);

const options = [
    { value: 'REMISION', label: 'Remisiones/Reparto' },
    { value: 'OTHER', label: 'Otro' },
];

const tipoComprobante = [
    { value: "FAC", label: "FAC" },
    { value: "RET", label: " RET" },
    { value: "NCR", label: " NCR" },
    { value: "REC", label: " REC" },
    { value: "AUT", label: " AUT" },
    { value: "FAE", label: " FAE" },
    { value: "CV", label: "CV" },
    { value: "ADEL", label: "ADEL" },
    { value: "EXT", label: "EXT" }
];

class PlanificacionSelector extends React.Component<PlanificacionSelectorProps, PlanificacionSelectorState> {

    refOrigin: StandaloneSearchBox;
    refDestiny: StandaloneSearchBox;

    constructor(props: PlanificacionSelectorProps) {
        super(props);
        this.state = {
            data: {
                originStreet: props.config.races.predefinedFrom ? 'Origen' : '',
                destinyStreet: '',
                clientDocument: '',
                clientLocations: [],
                selectedDriver: null,
                drivers: [],
                selectedType: '',
                items: [
                    { id: 'item-1', content: 'Item 1' },
                    { id: 'item-2', content: 'Item 2' },
                    { id: 'item-3', content: 'Item 3' },
                ],
                branchList: props.data && props.data.branchList ? props.data.branchList : [],
                ...props.data,
            },
            center: props.config.maps.startingLocation,

            filter: '',
            filterLoc: '',
            filterDir: '',
            pageNum: 0,
            pageSize: 3,
            totalItems: 0,
            locations: [],
            isDialogOpenLoc: false,
            isDialogOpenReparto: false,
            isDialogOpen: false,
            isDialogHojaOpen: false,
            openSearch: false,
            actions: new RaceActions(),
            selectedValue: 'REMISION',
            table: {
                data: [],
                sortBy: "name",
                sortDirection: "asc",
                columnData: [
                    {
                        path: "client.user.name",
                        label: "Cliente",
                        numeric: false,
                    },
                    {
                        path: "visitDateTime",
                        label: "Fecha",
                        numeric: false,
                    },
                    {
                        path: "type",
                        label: "Tipo de reparto",
                        numeric: false,
                        draw: (cd: ColumnDefinition, data: VisitsDetail) => {
                            return (data.order !== 1 &&
                                <Select value={data.type ? data.type : 'REMISION'} onChange={(event) => this.handleSelectChangeOnRow(event, data)}>
                                    {options.map((option, index) => (
                                        <MenuItem key={index} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            );
                        },
                    },
                    {
                        path: "tipoDocumento",
                        label: "Tipo de documento",
                        numeric: false,
                        draw: (cd: ColumnDefinition, data: VisitsDetail) => {
                            return (data.order !== 1 &&
                                <Select value={data.type ? data.type : 'FAC'} onChange={(event) => this.handleSelectChangeComprobanteOnRow(event, data)}>
                                    {tipoComprobante.map((option, index) => (
                                        <MenuItem key={index} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            );
                        },
                    },
                    {
                        path: "nroDocumento",
                        label: "Numero de documento (opcional)",
                        numeric: false,
                        draw: (cd: ColumnDefinition, data: VisitsDetail) => {
                            return (data.order !== 1 &&
                                <TextField
                                    label="Nro documento (opcional)"
                                    type="number"
                                    onChange={(e) => this.setNroComprobante(e, data)}
                                    value={data.nroComprobante || ''}
                                    style={{
                                        width: '90%'
                                    }}
                                    margin="normal"
                                />
                            );
                        },
                    },
                    {
                        path: "amount",
                        label: "Fijar precio (opcional)",
                        numeric: false,
                        draw: (cd: ColumnDefinition, data: VisitsDetail) => {
                            return (data.order !== 1 &&
                                <TextField
                                    label="Fijar precio (opcional)"
                                    type="number"
                                    inputProps={{ step: "100" }}
                                    onChange={(e) => this.setPrice(e, data)}
                                    value={data.amount || ''}
                                    style={{
                                        width: '90%'
                                    }}
                                    margin="normal"
                                />
                            );
                        },
                    },
                    {
                        path: "observations",
                        label: "Observaciones",
                        numeric: false,
                        draw: (cd: ColumnDefinition, data: VisitsDetail) => {
                            return (
                                <TextField
                                    id="observations"
                                    placeholder="Observaciones"
                                    multiline
                                    rows={3}
                                    value={data.observations}
                                    onChange={(event) =>
                                        this.handleObservationsChange(event, data)
                                    }
                                    style={{
                                        width: "90%",
                                    }}
                                    margin="normal"
                                />
                            );
                        },
                    },
                    {
                        path: "order",
                        label: "Orden",
                        numeric: false,
                        draw: (cd: ColumnDefinition, data: VisitsDetail) => {
                            return (
                                <TextField
                                    id="order"
                                    placeholder="Orden"
                                    type="text"
                                    value={data.order}
                                    onChange={(event) => this.handleOrderChange(event, data)}
                                    style={{
                                        width: "40%",
                                    }}
                                    margin="normal"
                                />
                            );
                        },
                    },
                    {
                        path: "",
                        numeric: true,
                        label: "Acciones",
                        draw: (cd: ColumnDefinition, data: VisitsDetail) => {
                            return (data.order && data.order > 1 &&
                                <div>
                                    <IconButton
                                        aria-label="Visitados"
                                        title="Visitados"
                                        onClick={() =>
                                            data.client && this.handleClickRemove(data && data.id ? data.id : 0)
                                        }
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </div>
                            );
                        },
                    },
                ],
            },
            confirmarOrdenFlag: false,
            visitsDetail: [],
            setPrice: 0,
            limit: 200,
            pageNumRace: 0,
            pageSizeRace: 3,
            totalItemsRace: 0,
            dataRace: [],
            filterRace: '',
            dateFromRace: '',
            dateToRace: '',
            type: '',
            driverId: 0,
            branchId: 0,
            branchDestinyId: 0,
            selectedState: '',

            // Form state for CSV upload
            vehicleCapacityBoxes: '',
            numVehicles: '',
            depotIndex: 0,
            serviceTime: 10,
            demandUnit: 'cajas',
            capacityUnit: 'cajas',
            boxVolumeM3: 0,
            csvLocationsFile: null,
            csvDriversFile: null,
            csvFleetFile: null,
            isUploading: false,

            // Routes data
            routesData: [],
            selectedRouteId: null,
            showRoutesOnMap: false,
            routeDirections: {},
            showMarkersOnly: true, // Por defecto solo mostrar marcadores
            maxVisibleRoutes: 20, // Límite de 20 rutas visibles simultáneamente (aumentado para soportar más rutas)

            // Excluded nodes data
            excludedNodes: [],
            excludedNodesExpanded: false,

            // Modal state for route details
            showRouteDetailsModal: false,
            selectedRouteForDetails: null,
            selectedBranches: [],
            selectedDrivers: [],
            branchDemands: {}, // Para almacenar las demandas personalizadas de cada sucursal
            driverCapacities: {}, // Para almacenar las capacidades personalizadas de cada conductor

            // Progress tracking for race creation
            isCreatingRaces: false,
            racesCreationProgress: 0,
            totalRacesToCreate: 0,
            racesCreated: 0,

            // Tab state
            selectedTab: 0, // 0 for CSV, 1 for System
            isCreatingBranches: false,
            branchesCreationProgress: 0,
            totalBranchesToCreate: 0,
            branchesCreated: 0,
            currentBatch: 0,
            totalBatches: 0,
            isCancellingBranches: false,
            retryAttempts: 0,
            maxRetries: 3,
            creationSummary: null,

            // Progress tracking for driver creation from CSV
            isCreatingDrivers: false,
            driversCreationProgress: 0,
            totalDriversToCreate: 0,
            driversCreated: 0,
            currentDriverBatch: 0,
            totalDriverBatches: 0,
            isCancellingDrivers: false,
            driverRetryAttempts: 0,
            driverMaxRetries: 3,
            driverCreationSummary: null,
        };

        this.onOriginMounted = this.onOriginMounted.bind(this);
        this.onDestinyMounted = this.onDestinyMounted.bind(this);

        this.handleOnClick = this.handleOnClick.bind(this);
        this.handleDragEnd = this.handleDragEnd.bind(this);
        this.fireNewDataEvent = this.fireNewDataEvent.bind(this);

        this.requestNewDirections = this.requestNewDirections.bind(this);
        this.getRouteDescription = this.getRouteDescription.bind(this);
        this.onChangeBranchSelector = this.onChangeBranchSelector.bind(this);
        this.onChangeBranchSelectorMult = this.onChangeBranchSelectorMult.bind(this);
        this.onChangeDriverSelectorMult = this.onChangeDriverSelectorMult.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.handleFormSubmitFromSystem = this.handleFormSubmitFromSystem.bind(this);
        this.handleBranchDemandChange = this.handleBranchDemandChange.bind(this);
        this.handleDriverCapacityChange = this.handleDriverCapacityChange.bind(this);
        this.isCSVFormValid = this.isCSVFormValid.bind(this);
        this.isSystemFormValid = this.isSystemFormValid.bind(this);
        this.handleReset = this.handleReset.bind(this);

    }

    componentDidUpdate(prevProps: PlanificacionSelectorProps) {
        if (prevProps.data !== this.props.data && this.props.data && this.props.data.branchList) {
            this.setState(prevState => ({
                data: {
                    ...prevState.data,
                    branchList: this.props.data!.branchList
                }
            }));
        }
        if (prevProps.data !== this.props.data && this.props.data && this.props.data.drivers) {
            console.log('Actualizando drivers en estado local:', this.props.data.drivers.length);
            this.setState(prevState => ({
                data: {
                    ...prevState.data,
                    drivers: this.props.data!.drivers
                }
            }));
        }
    }

    obtenerUbicaciones(pageNum: number, pageSize: number, filter: string, filterDir: string) {
        getApi().client().locations(pageNum, pageSize, filter, filterDir).then((data: any) => {
            this.setState({
                data: {
                    ...this.state.data,
                },
                locations: data.page,
                totalItems: data.totalElements
            });
        }).catch((error) => {
            console.error('Error during API call:', error);
        });
    }

    handleOnClick(args: google.maps.MouseEvent | google.maps.IconMouseEvent) {
        if (!this.state.data.origin) {
            this.setState({
                ...this.state,
                data: {
                    ...this.state.data,
                    origin: new Dot(args.latLng.lat(), args.latLng.lng())
                }
            });
            this.fireNewDataEvent(true);
            return;
        }

        if (!this.state.data.destiny) {
            this.setState({
                ...this.state,
                data: {
                    ...this.state.data,
                    destiny: new Dot(args.latLng.lat(), args.latLng.lng())
                }
            });
            this.fireNewDataEvent(true);
            return;
        }

    }

    async requestNewDirections(forceRename: boolean) {
        if (this.state.data.origin && this.state.data.destiny) {
            try {
                const data: DirectionsResult = await googleMaps.getDirections(this.state.data.origin,
                    this.state.data.destiny, this.props.config.maps.region);
                this.handleDirectionsData(data, forceRename);
            } catch (err) {
                this.setState({
                    data: {
                        ...this.state.data,
                        distance: undefined,
                        duration: undefined,
                        fullData: undefined,
                        price: undefined
                    }
                });
            }
        }
    }

    handleDirectionsData(data: DirectionsResult, forceNewPosition = true) {

        const route = data &&
            data.routes &&
            data.routes[0];

        const leg = route &&
            route.legs &&
            route.legs[0] &&
            route.legs[0];

        if (!leg) {
            return;
        }

        this.setState({
            data: {
                ...this.state.data,
                originStreet: forceNewPosition ? leg.start_address : this.state.data.originStreet || leg.start_address,
                destinyStreet: forceNewPosition ? leg.end_address : this.state.data.destinyStreet || leg.end_address,
                fullData: data,
                leg: leg,
                route: route,
                distance: leg.distance.value,
                duration: leg.duration.text,
                price: leg.distance.value / 1000 * this.state.setPrice !== 0 ? this.state.setPrice : this.props.config.races.pricePerKm
            }
        });
    }

    getRouteDescription() {
        const data = this.state.data;
        if (!data.fullData) {
            return (<Typography>Seleccione dos puntos para iniciar el calculo de ruta</Typography>)
        }

        return (
            <Typography>
                El viaje es de: <NumberFormat value={(Math.round(data.distance || 0))}
                    suffix={'Km.'}
                    displayType={'text'}
                    decimalScale={4} /> , y
                costará aproximadamente <MoneyLabel amount={data.price} />.
            </Typography>
        )
    }


    handleDragEnd(marker: MarkerType, index?: number, type?: string) {

        return async (e: google.maps.MouseEvent) => {
            if (this.state.data.visitsDetail && this.state.data.visitsDetail.length > 0 && type === 'O') {
                const newVisitDetail = this.state.data.visitsDetail;
                newVisitDetail[0].location = new Dot(e.latLng.lat(), e.latLng.lng());
                this.setState({
                    data: {
                        ...this.state.data,
                        [type === 'O' ? 'origin' : marker]: new Dot(e.latLng.lat(), e.latLng.lng()),
                        visitsDetail: newVisitDetail,
                    },
                });

                this.fireNewDataEvent(true);
                this.calculateWaypoints();
            } else {
                if (index !== undefined && this.state.data.visitsDetail) {
                    const data: DirectionsResult = await googleMaps.getDirections(this.state.data.visitsDetail[0].location,
                        new Dot(e.latLng.lat(), e.latLng.lng()), this.props.config.maps.region);
                    this.setState((prevState) => {
                        const visitsDetail = prevState.data.visitsDetail
                            ? [...prevState.data.visitsDetail]
                            : [];
                        visitsDetail[index].location = new Dot(
                            e.latLng.lat(),
                            e.latLng.lng()
                        );
                        visitsDetail[index].destiny = {
                            lat: e.latLng.lat(),
                            lng: e.latLng.lng(),
                            street1: data.routes[0].legs[0].end_address,
                        };

                        return {
                            data: {
                                ...prevState.data,
                                visitsDetail,
                            },
                        };
                    });
                }
                this.fireNewDataEvent(true);
                this.calculateWaypoints()
            }
        }
    }

    fireNewDataEvent(forceRename: boolean) {
        if (this.state.data.origin || this.state.data.destiny) {
            this.requestNewDirections(forceRename).then(() => {
                this.props.onNewData(this.state.data);
            });
        }
    }

    setNewPlace(ref: StandaloneSearchBox, type: MarkerType) {

        const places: PlaceResult[] = ref.getPlaces();
        const bounds = new google.maps.LatLngBounds();

        places.forEach((place: PlaceResult) => {
            if (place.geometry.viewport) {
                bounds.union(place.geometry.viewport)
            } else {
                bounds.extend(place.geometry.location)
            }
        });

        const nextMarkers = places.map((place: PlaceResult) => ({
            position: place.geometry.location
        }));
        const nextCenter = nextMarkers && nextMarkers[0] && nextMarkers[0].position || this.state.center;
        const centerDot = new Dot(nextCenter.lat(), nextCenter.lng());

        if (this.state.data.visitsDetail && this.state.data.visitsDetail.length > 0) {
            const newVisitDetail = this.state.data.visitsDetail;
            newVisitDetail[0].location = new Dot(nextCenter.lat(), nextCenter.lng());
            this.setState({
                data: {
                    ...this.state.data,
                    [type]: centerDot,
                    visitsDetail: newVisitDetail,
                },
                center: centerDot
            });
            this.fireNewDataEvent(true);
            this.calculateWaypoints();

        }

    }

    onPlaceSelected(type: MarkerType) {
        return () => {
            this.setNewPlace(type === 'origin' ? this.refOrigin : this.refDestiny, type);
        }
    }

    onOriginMounted(ref: StandaloneSearchBox) {
        this.refOrigin = ref;
        this.getSearchRegionBounds();
        // this.getBranchList();
        setTimeout(() => {
            this.onChangeBranchSelector({ target: { value: 0 } } as any);
        }, 1000);
    }

    onDestinyMounted(ref: StandaloneSearchBox) {
        this.refDestiny = ref;
    }


    async getSearchRegionBounds() {
        const bounds: LatLngBounds = await googleMaps.getGeoCodeBounds(this.props.config.maps.region);
        this.setState({
            data: {
                ...this.state.data,
                searchBounds: bounds
            }
        });
    }

    getLocationsByClientDocument(document: string) {
        getApi().admin().clientLocationByDocument(document).then((data) => {
            this.setState({
                data: {
                    ...this.state.data,
                    clientLocations: data
                }
            });

        }).catch(error => {
            this.setState({
                data: {
                    ...this.state.data,
                    clientLocations: undefined,
                    selectedClientLocation: undefined,
                    selectedClientLocationId: undefined
                }
            });
        });
    }

    onChangeBranchSelectorMult(e: React.ChangeEvent<{ value: unknown }>) {
        const selectedBranchIds = e.target.value as number[];

        // Inicializar demandas para las nuevas sucursales seleccionadas
        const newBranchDemands = { ...this.state.branchDemands };
        selectedBranchIds.forEach(branchId => {
            if (!newBranchDemands[branchId]) {
                newBranchDemands[branchId] = 10; // Valor por defecto
            }
        });

        // Remover demandas de sucursales deseleccionadas
        const deselectedBranches = this.state.selectedBranches.filter(id => !selectedBranchIds.includes(id));
        deselectedBranches.forEach(branchId => {
            delete newBranchDemands[branchId];
        });

        this.setState({
            selectedBranches: selectedBranchIds,
            branchDemands: newBranchDemands
        });
    }

    onChangeDriverSelectorMult(e: React.ChangeEvent<{ value: unknown }>) {
        const selectedDriverIds = e.target.value as number[];

        // Inicializar capacidades para los nuevos conductores seleccionados
        const newDriverCapacities = { ...this.state.driverCapacities };
        selectedDriverIds.forEach(driverId => {
            if (!newDriverCapacities[driverId]) {
                newDriverCapacities[driverId] = 50; // Valor por defecto
            }
        });

        // Remover capacidades de conductores deseleccionados
        const deselectedDrivers = this.state.selectedDrivers.filter(id => !selectedDriverIds.includes(id));
        deselectedDrivers.forEach(driverId => {
            delete newDriverCapacities[driverId];
        });

        this.setState({
            selectedDrivers: selectedDriverIds,
            driverCapacities: newDriverCapacities
        });
    }

    handleBranchDemandChange = (branchId: number, newDemand: number) => {
        this.setState(prevState => ({
            branchDemands: {
                ...prevState.branchDemands,
                [branchId]: newDemand
            }
        }));
    };

    handleDriverCapacityChange = (driverId: number, newCapacity: number) => {
        this.setState(prevState => ({
            driverCapacities: {
                ...prevState.driverCapacities,
                [driverId]: newCapacity
            }
        }));
    };

    isCSVFormValid = (): boolean => {
        return !!(
            this.state.csvLocationsFile &&
            this.state.csvFleetFile &&
            this.state.boxVolumeM3 > 0
        );
    };

    isSystemFormValid = (): boolean => {
        return !!(
            this.state.selectedBranches.length > 0 &&
            this.state.selectedDrivers.length > 0 &&
            this.state.boxVolumeM3 > 0.01
        );
    };

    handleReset = () => {
        this.setState({
            // Reset CSV form fields
            vehicleCapacityBoxes: '',
            numVehicles: '',
            depotIndex: 0,
            serviceTime: 10,
            demandUnit: 'cajas',
            capacityUnit: 'cajas',
            boxVolumeM3: 0,
            csvLocationsFile: null,
            csvFleetFile: null,
            csvDriversFile: null,
            isUploading: false,

            // Reset system form fields
            selectedBranches: [],
            selectedDrivers: [],
            branchDemands: {},
            driverCapacities: {},

            // Reset routes data
            routesData: [],
            selectedRouteId: null,
            showRoutesOnMap: false,
            routeDirections: {},

            // Reset excluded nodes
            excludedNodes: [],
            excludedNodesExpanded: false,

            // Reset modal state
            showRouteDetailsModal: false,
            selectedRouteForDetails: null,

            // Reset progress tracking
            isCreatingRaces: false,
            racesCreationProgress: 0,
            totalRacesToCreate: 0,
            racesCreated: 0,
        });

        // Show success notification
        this.props.notification.notification.addInfo('Formulario limpiado correctamente');
    };

    onChangeBranchSelector(e: React.ChangeEvent<any>) {
        const idx = +e.target.value;
        this.setBranch(idx);
    }


    setBranch(idx: number) {
        const branch = this.state.data.branchList ? this.state.data.branchList[idx] : undefined;
        const origin = this.state.data.origin


        if (this.state.data.visitsDetail && this.state.data.visitsDetail.length > 0 && branch) {
            const newVisitDetail = this.state.data.visitsDetail;
            newVisitDetail[0].location = new Dot(branch.location.lat, branch.location.lng);
            // newVisitDetail[0].origin = {
            //     street1: 'Origen',
            //     lat: branch.location.lat,
            //     lng: branch.location.lng
            // }
            // Se vuelve a cambiar el origen del primer elemento que justamente no sea el origen de la ruta
            if (this.state.data.visitsDetail.length === 2) {
                newVisitDetail[this.state.data.visitsDetail.length - 1].origin = {
                    street1: 'Origen',
                    lat: branch.location.lat,
                    lng: branch.location.lng
                }
            }

            this.setState({
                data: {
                    ...this.state.data,
                    selectedBranch: branch,
                    origin: branch ? new Dot(branch.location.lat, branch.location.lng) : origin,
                    visitsDetail: newVisitDetail,
                }
            }, () => {
                this.fireNewDataEvent(true);
                this.calculateWaypoints();
            });
        }

        // podría ir aquí fireNewDataEvent
    }



    handleSelectChangeComprobanteOnRow = (event: React.ChangeEvent<HTMLSelectElement>, data: any) => {
        let newVisitsDetail = [];
        if (this.state.data && this.state.data.visitsDetail) {
            newVisitsDetail = this.state.data.visitsDetail;
            newVisitsDetail.forEach((item: any) => {
                if (item.id === data.id) {
                    item.tipoComprobante = event.target.value;
                }
            });
            this.setState({
                data: {
                    ...this.state.data,
                    visitsDetail: newVisitsDetail,
                },
            });
        }
    };

    getRaces(pageNum?: number, pageSize?: number, search?: string, from?: string, to?: string, sinCabecera?: boolean, status?: string, conOwner?: boolean) {
        getApi().race().all(pageNum, pageSize, search, from, to, undefined, undefined, status, sinCabecera, conOwner).then((data: any) => {

            this.setState({
                dataRace: Array.isArray(data.content) ? data.content : [],
                totalItemsRace: data.totalElements || 0
            });
        }).catch((error: any) => {
            console.error('Error loading races:', error);
            this.setState({
                dataRace: [],
                totalItemsRace: 0
            });
        })

    }




    handleSelectChangeOnRow = (event: React.ChangeEvent<HTMLSelectElement>, data: any) => {
        let newVisitsDetail = [];
        if (this.state.data && this.state.data.visitsDetail) {
            newVisitsDetail = this.state.data.visitsDetail;
            newVisitsDetail.forEach((item: any) => {
                if (item.id === data.id) {
                    item.type = event.target.value;
                }
            });
            this.setState({
                data: {
                    ...this.state.data,
                    visitsDetail: newVisitsDetail,
                },
            });
        }
    };
    handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedValue = event.target.value;
        this.setState({
            data: {
                ...this.state.data,
                selectedType: selectedValue,
            },
            selectedValue: event.target.value as string
        });
        // handle the selected value
    };

    async selectDriver(driver: Driver) {
        if (!driver || driver.referenceId == null) {
            if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addWarning) {
                this.props.notification.notification.addWarning('El conductor no tiene un ID de referencia válido.');
            } else {
                this.props.notification.notification.addWarning('El conductor no tiene un ID de referencia válido.');
            }
            return;
        }
        try {
            const today = new Date();
            const desde = format(today, "YYYY-MM-DDT00:00:00Z");
            const hasta = format(today, "YYYY-MM-DDTHH:mm:ssZ");
            const url = `https://ping.matizsae.com.py/tag/rest/pedidos-movil/marcacion/listar?personaId=${driver.referenceId}&desde=${desde}&hasta=${hasta}`;
            const resp = await fetch(url, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            });
            if (!resp.ok) {
                throw new Error('Error en la respuesta del servidor');
            }
            const data = await resp.json();
            if (Array.isArray(data) && data.length > 0) {
                this.setState(prevState => ({
                    data: {
                        ...prevState.data,
                        selectedDriver: driver
                    }
                }));
            } else {
                console.warn(this.props.notification);
                if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addWarning) {
                    this.props.notification.notification.addWarning('El conductor no tiene asistencias registradas para el día de hoy.');
                } else {
                    alert('El conductor no tiene asistencias registradas para el día de hoy.');
                }
            }
        } catch (error) {
            if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addWarning) {
                this.props.notification.notification.addWarning('No se pudo verificar la asistencia del conductor.');
            } else {
                alert('No se pudo verificar la asistencia del conductor.');
            }
            console.error('Error al obtener asistencias:', error);
        }
    }
    validateData(data: any) {
        let missingKeys = '';
        for (let key in data) {
            if (data[key] === null || data[key] === '' || data[key] === undefined || data[key].length === 0) {
                key === 'selectedDriver' ? key = 'Conductor' : key === 'races' ? key = 'Clientes a repartir' : key = '';
                missingKeys += key + ', ';
            }
        }

        return missingKeys !== '' ? missingKeys.slice(0, -2) : true; // remove last ', '
    }

    handleSubmit = async () => {
        // Verificar si tenemos datos de rutas optimizadas
        if (this.state.routesData && this.state.routesData.length > 0) {
            // Inicializar progreso
            const totalRaces = this.state.routesData.length;
            this.setState({
                isCreatingRaces: true,
                racesCreationProgress: 0,
                totalRacesToCreate: totalRaces,
                racesCreated: 0
            });

            // Mostrar notificación de inicio
            if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addInfo) {
                this.props.notification.notification.addInfo('Iniciando creación de carreras', `Creando ${totalRaces} carreras optimizadas...`);
            }

            // Obtener todos los conductores seleccionados de manera similar al render
            const selectedDriversData = this.state.data.drivers && this.state.data.drivers.filter(driver =>
                this.state.selectedDrivers.includes(driver.id)
            ) || [];


            try {
                // Usar datos de rutas optimizadas - enviar una por cada driver/vehículo individualmente
                for (let i = 0; i < this.state.routesData.length; i++) {
                    const route = this.state.routesData[i];

                    // Actualizar progreso
                    this.setState(prevState => ({
                        racesCreationProgress: ((i) / totalRaces) * 100,
                    }));

                    // Pequeña pausa para mostrar progreso visualmente
                    await new Promise(resolve => setTimeout(resolve, 200));

                    // El vehiculoId del servidor corresponde al índice en el array (1-based),
                    // pero ahora usamos la matrícula para mapear al driver correcto
                    const driverIndex = route.vehiculoId - 1;
                    let selectedDriver = selectedDriversData[driverIndex];

                    // Intentar mapear por matrícula para asegurar el driver correcto
                    if (route.matricula) {
                        const mappedDriverId = this.getDriverIdByMatricula(route.matricula);
                        if (mappedDriverId) {
                            // Buscar el driver mapeado en TODOS los drivers disponibles
                            const mappedDriver = this.state.data.drivers && this.state.data.drivers.find(d => d.id === mappedDriverId);
                            if (mappedDriver) {
                                selectedDriver = mappedDriver;
                            } else {
                                console.warn(`Driver mapping: matricula "${route.matricula}" maps to driver ID ${mappedDriverId} but not found in drivers list`);
                            }
                        } else {
                            console.warn(`Driver mapping: Could not map matricula "${route.matricula}" to any driver`);
                        }
                    }

                    // También verificar si la ruta ya tiene un driverId mapeado
                    if (route.driverId) {
                        const routeDriver = this.state.data.drivers && this.state.data.drivers.find(d => d.id === route.driverId);
                        if (routeDriver) {
                            selectedDriver = routeDriver;
                        }
                    }

                    // Asegurar que el driver seleccionado esté en la lista de drivers seleccionados
                    if (selectedDriver && !this.state.selectedDrivers.includes(selectedDriver.id)) {
                        this.setState(prevState => ({
                            selectedDrivers: [...prevState.selectedDrivers, selectedDriver.id]
                        }));
                    }

                    // Obtener la sucursal base del driver asignado
                    const branchOrigin = selectedDriver && selectedDriver.branch ? selectedDriver.branch :
                        (this.state.data.selectedBranch ||
                            (this.state.data.branchList && this.state.data.branchList.find(branch =>
                                this.state.selectedBranches.includes(branch.id)
                            )));

                    // Crear routeVisitsDetail basado en las paradas de la ruta - cada race es un trayecto
                    const routeVisitsDetail = [];
                    if (route.paradas && route.paradas.length > 0) {

                        // Obtener origen (sucursal base del driver)
                        const origenCoords = branchOrigin ? [branchOrigin.location.lng, branchOrigin.location.lat] : [0, 0];
                        const origenName = branchOrigin ? branchOrigin.name : 'Origen';

                        // Filtrar solo las paradas de tipo "Cliente" (excluyendo depósitos)
                        const paradasClientes = route.paradas.filter(p => p.tipoParada === "Cliente");

                        // Obtener depósito de salida y llegada
                        const depositoSalida = route.paradas.find(p => p.tipoParada === "Depósito (Salida)");
                        const depositoLlegada = route.paradas.find(p => p.tipoParada === "Depósito (Llegada)");

                        // Crear races solo entre: depósito → clientes → depósito
                        for (let j = 0; j < paradasClientes.length; j++) {
                            const paradaActual = paradasClientes[j];

                            // Determinar origen y destino del trayecto
                            let origenTrayecto;
                            let destinoTrayecto;
                            let clienteDestino;
                            let clienteOrigen; // Para obtener el branchOriginId

                            if (j === 0) {
                                // Primer trayecto: depósito salida → primera parada cliente
                                const origen = depositoSalida || { nombreSucursal: origenName, coordenadas: origenCoords };
                                origenTrayecto = {
                                    street1: origen.nombreSucursal,
                                    lat: origen.coordenadas[1],
                                    lng: origen.coordenadas[0]
                                };
                                destinoTrayecto = {
                                    street1: paradaActual.nombreSucursal,
                                    lat: paradaActual.coordenadas[1],
                                    lng: paradaActual.coordenadas[0]
                                };
                                clienteDestino = paradaActual;
                                clienteOrigen = null; // El origen es el depósito, no un cliente
                            } else {
                                // Trayectos intermedios: cliente anterior → cliente actual
                                const paradaAnterior = paradasClientes[j - 1];
                                origenTrayecto = {
                                    street1: paradaAnterior.nombreSucursal,
                                    lat: paradaAnterior.coordenadas[1],
                                    lng: paradaAnterior.coordenadas[0]
                                };
                                destinoTrayecto = {
                                    street1: paradaActual.nombreSucursal,
                                    lat: paradaActual.coordenadas[1],
                                    lng: paradaActual.coordenadas[0]
                                };
                                clienteDestino = paradaActual;
                                clienteOrigen = paradaAnterior; // El origen es el cliente anterior
                            }

                            // Mapear el nombreSucursal del destino a su branchId real
                            const branchDestinoId = this.getBranchIdByName(clienteDestino.nombreSucursal);

                            // Mapear el nombreSucursal del origen a su branchId real
                            // Para el primer trayecto, usar el branchOrigin del driver
                            // Para trayectos intermedios, usar el branchId del cliente anterior
                            const branchOrigenId = j === 0
                                ? (branchOrigin ? branchOrigin.id : null) // Primer trayecto: branch base del driver
                                : (clienteOrigen ? this.getBranchIdByName(clienteOrigen.nombreSucursal) : null); // Cliente anterior

                            routeVisitsDetail.push({
                                client: {
                                    id: branchDestinoId || clienteDestino.nodoId || (j + 1), // Usar branchId mapeado, fallback a nodoId
                                    user: {
                                        name: clienteDestino.nombreSucursal || `Parada ${j + 1}`,
                                        email: ''
                                    },
                                    phone: ''
                                },
                                visitDateTime: clienteDestino.horaLlegada ?
                                    new Date(new Date().toDateString() + ' ' + clienteDestino.horaLlegada) :
                                    new Date(),
                                location: destinoTrayecto,
                                observation: `Cajas a entregar: ${clienteDestino.cajasAEntregar}, Ventana: ${clienteDestino.ventanaTiempo || 'Sin restricción'}`,
                                order: j + 1,
                                street1: destinoTrayecto.street1,
                                type: 'REMISION',
                                amount: this.props.config.races.pricePerKm,
                                driver: selectedDriver,
                                clientName: clienteDestino.nombreSucursal,
                                clientDocument: '',
                                origin: origenTrayecto,
                                destiny: destinoTrayecto,
                                dueDate: clienteDestino.horaLlegada ?
                                    format(new Date(new Date().toDateString() + ' ' + clienteDestino.horaLlegada), "YYYY-MM-DDTHH:mm:ssZ") :
                                    format(new Date(), "YYYY-MM-DDTHH:mm:ssZ"),
                                tipoComprobante: 'FAC',
                                nroComprobante: 0,
                                id: branchDestinoId || clienteDestino.nodoId || (j + 1), // Usar branchId mapeado, fallback a nodoId
                                branchId: branchDestinoId, // Agregar campo explícito para tracking
                                branchOriginId: branchOrigenId || null, // ID de la sucursal de origen o null
                                branchDestinyId: branchDestinoId || null // ID de la sucursal destino o null
                            });
                        }

                        // Agregar race final: último cliente → depósito llegada
                        if (paradasClientes.length > 0) {
                            const ultimaParadaCliente = paradasClientes[paradasClientes.length - 1];
                            const destino = depositoLlegada || { nombreSucursal: origenName, coordenadas: origenCoords };

                            // Obtener el branchId real del último cliente (origen del retorno)
                            const branchOrigenRetorno = this.getBranchIdByName(ultimaParadaCliente.nombreSucursal);

                            // Obtener el branchId real del depósito de retorno (destino del retorno, solo si existe branchOrigin)
                            const branchDestinoRetorno = branchOrigin ? branchOrigin.id : null;

                            routeVisitsDetail.push({
                                client: {
                                    id: 9999,
                                    user: {
                                        name: destino.nombreSucursal + ' (Retorno)',
                                        email: ''
                                    },
                                    phone: ''
                                },
                                visitDateTime: new Date(),
                                location: {
                                    lat: destino.coordenadas[1],
                                    lng: destino.coordenadas[0]
                                },
                                observation: 'Retorno al depósito',
                                order: paradasClientes.length + 1,
                                street1: destino.nombreSucursal,
                                type: 'RETORNO',
                                amount: this.props.config.races.pricePerKm,
                                driver: selectedDriver ? selectedDriver.id : (route.matricula ? this.getDriverIdByMatricula(route.matricula) || route.vehiculoId : route.vehiculoId),
                                clientName: destino.nombreSucursal,
                                clientDocument: '',
                                origin: {
                                    street1: ultimaParadaCliente.nombreSucursal,
                                    lat: ultimaParadaCliente.coordenadas[1],
                                    lng: ultimaParadaCliente.coordenadas[0]
                                },
                                destiny: {
                                    street1: destino.nombreSucursal,
                                    lat: destino.coordenadas[1],
                                    lng: destino.coordenadas[0]
                                },
                                dueDate: format(new Date(), "YYYY-MM-DDTHH:mm:ssZ"),
                                tipoComprobante: 'FAC',
                                nroComprobante: 0,
                                id: 9999,
                                branchOriginId: branchOrigenRetorno || null, // ID de la sucursal del último cliente
                                branchDestinyId: branchDestinoRetorno // ID de la sucursal del depósito o null
                            });
                        }

                        // No agregar trayecto adicional de retorno - el último race ya incluirá el retorno al origen
                    }

                    // Crear la estructura de datos original para este vehículo
                    const data: any = {
                        visitDateTimeSchedule: format(new Date(), "YYYY-MM-DDTHH:mm:ssZ"),
                        selectedDriver: selectedDriver ? selectedDriver.id : (route.matricula ? this.getDriverIdByMatricula(route.matricula) || route.vehiculoId : route.vehiculoId),
                        limit: this.state.limit,
                        branch: branchOrigin, // Agregar branch en la cabecera
                        races: routeVisitsDetail.map((item: any, index: number) => {
                            const race: any = {
                                clientId: item.branchId || item.client.id, // Usar branchId explícito primero
                                visitDateTime: format(item.visitDateTime, "YYYY-MM-DDTHH:mm:ssZ"),
                                location: {
                                    lat: item.location.lat,
                                    lng: item.location.lng,
                                },
                                obs: item.observation ? item.observation : '',
                                order: index + 1,
                                street1: item.street1,
                                type: item.type ? item.type : 'REMISION',
                                amount: item.amount && item.amount !== 0 ? item.amount : this.props.config.races.pricePerKm,
                                driver: selectedDriver ? selectedDriver.id : (route.matricula ? this.getDriverIdByMatricula(route.matricula) || route.vehiculoId : route.vehiculoId),
                                clientName: item.clientName,
                                clientDocument: item.clientDocument,
                                origin: item.origin,
                                destiny: item.destiny,
                                dueDate: item.dueDate && item.dueDate !== '' ?
                                    format(new Date(item.dueDate), "YYYY-MM-DDTHH:mm:ssZ") :
                                    format(new Date(), "YYYY-MM-DDTHH:mm:ssZ"),
                                tipoComprobante: item.tipoComprobante ? item.tipoComprobante : 'FAC',
                                nroComprobante: item.nroComprobante ? item.nroComprobante : 0,
                                observation: item.observation ? item.observation : '',
                                branchOriginId: item.branchOriginId, // ID de la sucursal de origen
                                branchDestinyId: item.branchDestinyId // ID de la sucursal destino
                            };

                            // Agregar branch si está disponible
                            if (branchOrigin) {
                                race.branch = branchOrigin;
                            }

                            return race;
                        })
                    };

                    // Enviar datos individualmente para cada vehículo
                    try {
                        this.props.sendData(data);
                    } catch (immediateError) {
                        console.error(`Error inmediato enviando vehículo ${route.vehiculoId}:`, immediateError);
                        // Mostrar error inmediato si no se puede enviar
                        if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addError) {
                            this.props.notification.notification.addError('Error de conexión', `No se pudo enviar los datos del vehículo ${route.vehiculoId}`);
                        }
                    }

                    // Actualizar progreso - race completado
                    this.setState(prevState => ({
                        racesCreated: prevState.racesCreated + 1,
                        racesCreationProgress: ((i + 1) / totalRaces) * 100
                    }));
                }

                // Mostrar progreso completo por un momento
                await new Promise(resolve => setTimeout(resolve, 500));

            } catch (error) {
                console.error('Error creando carreras:', error);
                // Mostrar notificación de error directamente
                if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addError) {
                    this.props.notification.notification.addError('Error al crear las carreras', `Se produjo un error: ${error.message || error}`);
                } else {
                    alert(`Error al crear las carreras: ${error.message || error}`);
                }
            } finally {
                // Aquí solo reseteamos el estado de progreso
                this.setState({
                    isCreatingRaces: false,
                    racesCreationProgress: 0,
                    totalRacesToCreate: 0,
                    racesCreated: 0
                });
            }

            return;
        }

        // Código original para cuando no hay rutas optimizadas
        const visitsDetail = this.state.data.visitsDetail;
        const dataToValidate: any = {
            visitDateTimeSchedule: format(new Date(), "YYYY-MM-DDTHH:mm:ssZ"),
            selectedDriver: this.state.data.selectedDriver
                ? this.state.data.selectedDriver.id
                : undefined,
            limit: this.state.limit,
            races: this.state.data.visitsDetail
                ? this.state.data.visitsDetail.map((item: any, index: number) => {
                    return {
                        branchOrigin: this.state.data.selectedBranch,
                        clientId: item.client.id,
                        visitDateTime: format(item.visitDateTime, "YYYY-MM-DDTHH:mm:ssZ"),
                        location: {
                            lat: item.location.lat,
                            lng: item.location.lng,
                        },
                        obs: item.observation ? item.observation : '',
                        order: index + 1,
                        street1: item.street1,
                        type: item.type ? item.type : 'REMISION',
                        amount: item.amount && item.amount !== 0 ? item.amount : this.props.config.races.pricePerKm,
                        driver: typeof item.driver === 'object' && item.driver !== null ? item.driver.id : item.driver,
                        clientName: item.clientName,
                        clientDocument: item.clientDocument,
                        origin: item.origin,
                        destiny: item.destiny,
                        dueDate: item.dueDate,
                        tipoComprobante: item.tipoComprobante ? item.tipoComprobante : 'FAC',
                        nroComprobante: item.nroComprobante ? item.nroComprobante : 0,
                        observation: item.observation ? item.observation : '',
                    };
                })
                : null,
        };

        const dataIsValid = this.validateData(dataToValidate);

        if (dataIsValid === true) {
            if (visitsDetail && visitsDetail.length > 0) {
                visitsDetail.shift();
                this.setState(prevState => ({
                    data: {
                        ...prevState.data,
                        visitsDetail: visitsDetail
                    }
                }));
            }

            const data: any = {
                visitDateTimeSchedule: format(new Date(), "YYYY-MM-DDTHH:mm:ssZ"),
                selectedDriver: this.state.data.selectedDriver
                    ? this.state.data.selectedDriver.id
                    : undefined,
                limit: this.state.limit,
                races: this.state.data.visitsDetail
                    ? this.state.data.visitsDetail.map((item: any, index: number) => {
                        return {
                            branchOrigin: this.state.data.selectedBranch,
                            clientId: item.client.id,
                            visitDateTime: format(item.visitDateTime, "YYYY-MM-DDTHH:mm:ssZ"),
                            location: {
                                lat: item.location.lat,
                                lng: item.location.lng,
                            },
                            obs: item.observation ? item.observation : '',
                            order: index + 1,
                            street1: item.street1,
                            type: item.type ? item.type : 'REMISION',
                            amount: item.amount && item.amount !== 0 ? item.amount : this.props.config.races.pricePerKm,
                            driver: typeof item.driver === 'object' && item.driver !== null ? item.driver.id : item.driver,
                            clientName: item.clientName,
                            clientDocument: item.clientDocument,
                            origin: item.origin,
                            destiny: item.destiny,
                            dueDate: item.dueDate && item.dueDate !== '' ?
                                format(new Date(item.dueDate), "YYYY-MM-DDTHH:mm:ssZ") :
                                format(new Date(), "YYYY-MM-DDTHH:mm:ssZ"),
                            tipoComprobante: item.tipoComprobante ? item.tipoComprobante : 'FAC',
                            nroComprobante: item.nroComprobante ? item.nroComprobante : 0,
                            observation: item.observation ? item.observation : '',
                        };
                    })
                    : null,
            };

            // Enviar datos
            this.props.sendData(data);
        } else {
            if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addWarning) {
                this.props.notification.notification.addWarning('Faltan datos por completar: ' + dataIsValid);
            } else {
                this.props.notification.notification.addWarning('Faltan datos por completar: ' + dataIsValid);
            }
        }
    }
    handleCancel() {
        this.setState({
            data: {
                ...this.state.data,
                selectedDriver: undefined,
                visitsDetail: [],
                fullData: undefined,
            }
        })

    }

    handleOrderChange = (event: any, data: any) => {
        let newVisitDetail: any = [];
        if (Number(event.target.value) === 1) { return }
        if (this.state.data && this.state.data.visitsDetail) {
            newVisitDetail = this.state.data.visitsDetail;
            newVisitDetail.forEach((item: any) => {
                if (item.id === data.id) {
                    const newValue = event.target.value;
                    const isValueUsed = newVisitDetail.some((otherItem: any) => otherItem.id !== data.id && otherItem.order === newValue);
                    const previousItem = newVisitDetail.find((otherItem: any) => otherItem.order === item.order - 1);
                    if (!isValueUsed && (!previousItem || newValue > previousItem.order) && newValue <= newVisitDetail.length && newValue !== 1) {
                        item.order = newValue;
                    }
                }
            });

            this.setState({
                data: {
                    ...this.state.data,
                    visitsDetail: newVisitDetail,
                },
            });
        }
    };

    handleObservationsChange = (event: any, data: any) => {
        let newVisitsDetail = [];
        if (this.state.data && this.state.data.visitsDetail) {
            newVisitsDetail = this.state.data.visitsDetail;
            newVisitsDetail.forEach((item: any) => {
                if (item.id === data.id) {
                    item.observation = event.target.value;
                }
            });
            this.setState({
                data: {
                    ...this.state.data,
                    visitsDetail: newVisitsDetail,
                },
            });
        }
    };
    handleClickRemove(id: number) {
        if (this.state.data.visitsDetail) {
            this.setState({
                data: {
                    ...this.state.data,
                    visitsDetail: this.state.data.visitsDetail.filter(
                        (item: any) => item.id !== id
                    ),
                },
            }, () => {
                this.reorganizateOrder(true);
                this.calculateWaypoints();
            });
        }
    }
    reorganizateDrag(overwrite: boolean = false) {
        if (this.state.data.visitsDetail) {
            const visDetail = this.state.data.visitsDetail.sort((a: any, b: any) => {
                return a.order - 1 - (b.order - 1);
            }).map((item: any, index: number) => {

                return {
                    ...item,
                    order: !overwrite ? item.order : index + 1,
                    amount: item.amount && item.amount !== 0 ? item.amount : 0
                };
            });

            this.setState({
                data: {
                    ...this.state.data,
                    visitsDetail: visDetail
                },
            }, () => {
                this.setState({ confirmarOrdenFlag: false })
                this.calculateWaypoints(false);

            });
        }
    }
    reorganizateOrder(overwrite: boolean = false) {
        if (this.state.data.visitsDetail) {
            const visDetail = this.state.data.visitsDetail.sort((a: any, b: any) => {
                return a.order - 1 - (b.order - 1);
            }).map((item: any, index: number) => {
                return {
                    ...item,
                    order: !overwrite ? item.order : index + 1,
                    amount: item.amount && item.amount !== 0 ? item.amount : 0
                };
            });

            this.setState({
                data: {
                    ...this.state.data,
                    visitsDetail: visDetail
                },
            }, () => {
                this.setState({ confirmarOrdenFlag: false })
                this.calculateWaypoints(false);

            });
        }
    }
    cleanOrder() {
        if (this.state.data.visitsDetail) {
            this.setState({
                confirmarOrdenFlag: true,
                data: {
                    ...this.state.data,
                    visitsDetail: this.state.data.visitsDetail.map((item: any, index: number) => {
                        return {
                            ...item,
                            order: item.order === 1 ? 1 : '',
                        };
                    }),
                    fullData: undefined,
                },
            }, () => {
                // this.calculateWaypoints();

            });
        }
    }


    calculateWaypoints(optimized: boolean = false) {
        if (this.state.data.visitsDetail && this.state.data.visitsDetail.length >= 1) {
            const directionsService = new google.maps.DirectionsService();
            // const directionsRenderer = new google.maps.DirectionsRenderer();

            const origin = this.state.data.origin;
            const destiny = this.state.data.visitsDetail && this.state.data.visitsDetail[this.state.data.visitsDetail.length - 1] ? this.state.data.visitsDetail[this.state.data.visitsDetail.length - 1] : undefined;
            // const destiny = this.state.data.visitsDetail && this.state.data.visitsDetail[this.state.data.visitsDetail.length - 1]
            //     && this.state.data.visitsDetail[this.state.data.visitsDetail.length - 1].order !== 1 ? this.state.data.visitsDetail[this.state.data.visitsDetail.length - 1] : undefined;

            directionsService.route(
                {
                    origin: origin ? new google.maps.LatLng(origin.lat, origin.lng) : new google.maps.LatLng(0, 0),
                    destination: destiny ? new google.maps.LatLng(destiny.location.lat, destiny.location.lng) : new google.maps.LatLng(0, 0),
                    waypoints: this.state.data.visitsDetail ? this.state.data.visitsDetail.map((loc) => ({
                        location: new google.maps.LatLng(loc.location.lat, loc.location.lng),
                        stopover: true,
                    })) : [],
                    travelMode: google.maps.TravelMode.DRIVING,
                    optimizeWaypoints: optimized,
                },
                (result, status) => {
                    if (status === google.maps.DirectionsStatus.OK) {
                        const waypointOrder = result.routes[0].waypoint_order;
                        const orderedRoutes = waypointOrder.map(index => result.routes[0].legs[index]);

                        result.routes[0].legs = orderedRoutes;

                        // Calcular la distancia total de la ruta
                        let totalDistance = 0;
                        for (const leg of result.routes[0].legs) {
                            totalDistance += leg.distance.value;
                        }
                        // Convertir la distancia a kilómetros
                        totalDistance = totalDistance / 1000;

                        const prePrecio = Number(this.state.setPrice) !== 0 ? this.state.setPrice : this.props.config.races.pricePerKm
                        const precio = totalDistance * prePrecio;

                        if (this.state.data.visitsDetail && waypointOrder && optimized) {
                            const orderedVisits: any = waypointOrder.map((index, idx) => {
                                if (this.state.data.visitsDetail) {
                                    return { ...this.state.data.visitsDetail[index], order: idx + 1 };
                                }
                                return {};
                            });
                            this.setState({
                                data: {
                                    ...this.state.data,
                                    visitsDetail: orderedVisits,
                                },
                            });
                        }
                        this.setState({
                            // line: result.routes[0].overview_polyline,
                            data: {
                                ...this.state.data,
                                distance: totalDistance,
                                price: Number(precio),
                                fullData: result,
                            },
                        });
                    } else {
                        console.error(`Error fetching directions ${result.routes}`);
                    }
                }
            );
        } else {
            console.error("No hay visitas para calcular ruta");
            this.setState({
                data: {
                    ...this.state.data,
                    fullData: undefined,
                },
            });
        }
    }

    setNroComprobante(e: React.ChangeEvent<HTMLInputElement>, data: any) {
        let newVisitsDetail = [];
        if (this.state.data && this.state.data.visitsDetail) {
            newVisitsDetail = this.state.data.visitsDetail;
            newVisitsDetail.forEach((item: any) => {
                if (item.id === data.id) {
                    item.nroComprobante = e.target.value;
                }
            });
            this.setState({
                data: {
                    ...this.state.data,
                    visitsDetail: newVisitsDetail,
                },
            });
        }
    }
    setPrice(e: React.ChangeEvent<HTMLInputElement>, data: any) {
        let newVisitsDetail = [];
        if (this.state.data && this.state.data.visitsDetail) {
            newVisitsDetail = this.state.data.visitsDetail;
            newVisitsDetail.forEach((item: any) => {
                if (item.id === data.id) {
                    item.amount = e.target.value;
                }
            });
            this.setState({
                data: {
                    ...this.state.data,
                    visitsDetail: newVisitsDetail,
                },
            });
        }
    }

    // Form methods for CSV upload
    handleVehicleCapacityChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ vehicleCapacityBoxes: event.target.value });
    };

    handleNumVehiclesChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ numVehicles: event.target.value });
    };

    handleDepotIndexChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ depotIndex: parseInt(event.target.value, 10) || 0 });
    };

    handleServiceTimeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ serviceTime: parseInt(event.target.value, 10) || 10 });
    };

    handleDemandUnitChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        this.setState({ demandUnit: event.target.value as string });
    };

    handleCapacityUnitChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        this.setState({ capacityUnit: event.target.value as string });
    };

    handleBoxVolumeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ boxVolumeM3: parseFloat(event.target.value) || 0 });
    };

    // Método auxiliar para parsear líneas CSV correctamente
    parseCSVLine = (line: string): string[] => {
        const result: string[] = [];
        let current = '';
        let inQuotes = false;

        for (let i = 0; i < line.length; i++) {
            const char = line[i];
            const nextChar = line[i + 1];

            if (char === '"') {
                if (inQuotes && nextChar === '"') {
                    // Comilla escapada dentro de comillas (comillas dobles consecutivas)
                    current += '"';
                    i++; // Saltar la siguiente comilla
                } else {
                    // Entrar o salir de modo comillas
                    inQuotes = !inQuotes;
                }
            } else if (char === ',' && !inQuotes) {
                // Fin de campo
                result.push(current);
                current = '';
            } else {
                current += char;
            }
        }

        // Agregar el último campo
        result.push(current);

        return result;
    };

    // Método para procesar y registrar sucursales nuevas desde CSV
    processNewBranchesFromCSV = async (newBranches: any[]) => {
        if (newBranches.length === 0) {
            return;
        }

        // Verificar si hay callback disponible
        if (!this.props.onCreateBranches) {
            console.warn('No hay callback onCreateBranches disponible para crear sucursales');
            if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addWarning) {
                this.props.notification.notification.addWarning(
                    'Funcionalidad no disponible',
                    'No se puede registrar sucursales desde CSV en este contexto'
                );
            }
            return;
        }

        console.log('=== Registrando sucursales nuevas desde CSV ===');
        console.log('Sucursales a registrar:', newBranches.length);

        // Inicializar progreso
        this.setState({
            isCreatingBranches: true,
            branchesCreationProgress: 0,
            totalBranchesToCreate: newBranches.length,
            branchesCreated: 0,
            currentBatch: 0,
            totalBatches: Math.ceil(newBranches.length / 10), // Asumiendo batch size de 10
            isCancellingBranches: false,
            retryAttempts: 0,
            creationSummary: null
        });

        try {
            // Preparar los payloads de las sucursales nuevas
            const branchPayloads = newBranches.map((branchData) => {
                // Parsear ventana de tiempo (formato esperado: "HH:mm-HH:mm")
                let inicioVentana = "";
                let finVentana = "";
                if (branchData.ventana_tiempo && branchData.ventana_tiempo.includes('-')) {
                    const partes = branchData.ventana_tiempo.split('-');
                    inicioVentana = partes[0].trim();
                    finVentana = partes[1].trim();
                }

                return {
                    name: branchData.sucNom,
                    lat: branchData.sucLat,
                    lng: branchData.sucLon,
                    street1: branchData.sucNom, // Usar el nombre como dirección por defecto
                    street2: "", // Campo opcional vacío
                    observation: "Creada desde CSV - Ventana: " + branchData.ventana_tiempo + ", Cajas: " + branchData.can_cajas,
                    maxDistanceValidation: false, // Valor por defecto
                    maxDistance: 0, // Valor por defecto
                    inicioVentana: inicioVentana,
                    finVentana: finVentana
                };
            });

            console.log('Payloads preparados:', branchPayloads);

            // Llamar al callback del componente padre
            await this.props.onCreateBranches(branchPayloads);

            // Actualizar progreso final
            this.setState({
                branchesCreated: newBranches.length,
                branchesCreationProgress: 100
            });

            // Mostrar notificación de éxito
            if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addSuccess) {
                this.props.notification.notification.addSuccess(
                    'Sucursales registradas exitosamente',
                    `Se registraron ${newBranches.length} sucursales nuevas desde el CSV.`
                );
            }



            console.log('=== Registro completado ===');
            console.log('Total sucursales registradas:', newBranches.length);

        } catch (error) {
            console.error('Error durante el registro de sucursales:', error);
            if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addError) {
                this.props.notification.notification.addError(
                    'Error al registrar sucursales',
                    'Ocurrió un error durante el proceso de registro. Revisa la consola para más detalles.'
                );
            }
        } finally {
            // Limpiar estado de progreso después de un breve delay
            setTimeout(() => {
                this.setState({
                    isCreatingBranches: false,
                    branchesCreationProgress: 0,
                    totalBranchesToCreate: 0,
                    branchesCreated: 0
                });
            }, 2000);
        }
    };

    processNewDriversFromCSV = async (newDrivers: any[]) => {
        if (newDrivers.length === 0) {
            return;
        }

        // Verificar si hay callback disponible
        if (!this.props.onCreateDrivers) {
            console.warn('No hay callback onCreateDrivers disponible para crear choferes');
            if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addWarning) {
                this.props.notification.notification.addWarning(
                    'Funcionalidad no disponible',
                    'No se puede registrar choferes desde CSV en este contexto'
                );
            }
            return;
        }

        console.log('=== Registrando choferes nuevos desde CSV ===');
        console.log('Choferes a registrar:', newDrivers.length);

        // Inicializar progreso
        this.setState({
            isCreatingDrivers: true,
            driversCreationProgress: 0,
            totalDriversToCreate: newDrivers.length,
            driversCreated: 0,
            currentDriverBatch: 0,
            totalDriverBatches: Math.ceil(newDrivers.length / 10), // Asumiendo batch size de 10
            isCancellingDrivers: false,
            driverRetryAttempts: 0,
            driverCreationSummary: null
        });

        try {
            // Preparar los payloads de los choferes nuevos
            const driverPayloads = newDrivers.map((driverData) => {
                const tempPassword = 'TempPass123!';
                const tempEmail = `${driverData.chofer.toLowerCase().replace(/\s+/g, '.')}@temp.com`;

                return {
                    user: {
                        name: driverData.chofer, // Usar el nombre del chofer como name
                        email: tempEmail,
                        password: tempPassword
                    },
                    driver: {
                        region: 'DEFAULT',
                        registryNumber: driverData.matricula,
                        registryDate: new Date().toISOString().split('T')[0], // Fecha actual
                        phone: 'Sin teléfono',
                        document: 'Sin documento',
                        type: 'REMISION',
                        referenceId: 0,
                        notifyLocation: true,
                        notifyLogout: true,
                        recordLocation: true,
                        outsourced: false,
                        fixedPayment: 0,
                        paymentPerKm: 0
                    },
                    vehicle: {
                        brand: driverData.marca,
                        type: driverData.medidaFurgon === 'MOTORCYCLE' ? 'MOTORCYCLE' : 'CAR',
                        capacidadVolumetrica: driverData.m3
                        // Removido model y year que no están en el JSON que funciona
                    },
                    branch: driverData.branchId || 0, // Usar el ID de la sucursal encontrada o 0 por defecto
                    notifyLocation: false, // Según el JSON que funciona
                    notifyLogout: false,
                    recordLocation: false,
                    outsourced: false,
                    paymentPerKm: 0,
                    fixedPayment: 0,
                    driverPassw: tempPassword // Campo adicional requerido según el JSON que funciona
                };
            });

            console.log('Payloads preparados:', driverPayloads);

            // Llamar al callback del componente padre
            await this.props.onCreateDrivers(driverPayloads);

            // Refrescar la lista de drivers después de crearlos
            if (this.props.driverActions && this.props.driverActions.actions && this.props.driverActions.actions.fetch) {
                await this.props.driverActions.actions.fetch();
            }

            // Actualizar progreso final
            this.setState({
                driversCreated: newDrivers.length,
                driversCreationProgress: 100
            });

            // Mostrar notificación de éxito
            if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addSuccess) {
                this.props.notification.notification.addSuccess(
                    'Choferes registrados exitosamente',
                    `Se registraron ${newDrivers.length} choferes nuevos desde el CSV.`
                );
            }

            console.log('=== Registro completado ===');
            console.log('Total choferes registrados:', newDrivers.length);

        } catch (error) {
            console.error('Error durante el registro de choferes:', error);
            if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addError) {
                this.props.notification.notification.addError(
                    'Error al registrar choferes',
                    'Ocurrió un error durante el proceso de registro. Revisa la consola para más detalles.'
                );
            }
        } finally {
            // Limpiar estado de progreso después de un breve delay
            setTimeout(() => {
                this.setState({
                    isCreatingDrivers: false,
                    driversCreationProgress: 0,
                    totalDriversToCreate: 0,
                    driversCreated: 0,
                    currentDriverBatch: 0,
                    totalDriverBatches: 0
                });
            }, 2000);
        }
    };

    handleLocationsFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files ? event.target.files[0] : null;

        if (!file) {
            this.setState({ csvLocationsFile: null });
            return;
        }

        this.setState({ csvLocationsFile: file });

        // Leer y procesar el archivo CSV
        const reader = new FileReader();
        reader.onload = async (e: any) => {
            try {
                const target = e.target as FileReader;
                const text = target && target.result ? target.result as string : '';
                const lines = text.split('\n');

                // Obtener el arreglo de branches
                const branches = this.state.data.branchList || [];

                // Saltar la primera línea (encabezados)
                const dataLines = lines.slice(1).filter((line) => {
                    return line.trim() !== '';
                });

                console.log('=== Procesando CSV de Sucursales ===');
                console.log('Total de líneas en CSV: ' + dataLines.length);
                console.log('Total de branches existentes: ' + branches.length);

                // Procesar cada línea del CSV
                const results = dataLines.map((line, index) => {
                    try {
                        // Parsear la línea CSV de manera más robusta
                        let values = this.parseCSVLine(line);

                        // Si tenemos más de 5 campos, es probable que el nombre contenga comas
                        // Reconstruir el nombre concatenando campos hasta tener exactamente 5 campos
                        if (values.length > 5) {
                            console.warn(`Línea ${index + 2} tiene ${values.length} campos (más de 5). Intentando reconstruir nombre con comas:`, line);

                            // Los últimos 4 campos deberían ser: sucLon, sucLat, ventanaTiempo, canCajas
                            // Todo lo anterior es el nombre
                            const cantidadCajas = values[values.length - 1];
                            const ventanaTiemp = values[values.length - 2];
                            const sucLatitud = values[values.length - 3];
                            const sucLongitud = values[values.length - 4];
                            const sucNombre = values.slice(0, values.length - 4).join(',');

                            values = [sucNombre, sucLongitud, sucLatitud, ventanaTiemp, cantidadCajas];
                            console.log(`Nombre reconstruido: "${sucNombre}"`);
                        }

                        const cleanValues = values.map((v: string) => {
                            // Remover comillas dobles al inicio y final, pero preservar comillas internas
                            let cleaned = v.trim();
                            if (cleaned.startsWith('"') && cleaned.endsWith('"')) {
                                cleaned = cleaned.slice(1, -1);
                                // Des-escapar comillas dobles consecutivas
                                cleaned = cleaned.replace(/""/g, '"');
                            }
                            return cleaned;
                        });

                        if (cleanValues.length !== 5) {
                            console.warn(`Línea ${index + 2} tiene formato incorrecto (${cleanValues.length} campos en lugar de 5):`, line);
                            console.warn('Campos parseados:', cleanValues);
                            return null;
                        }

                    const sucNom = cleanValues[0];
                    const sucLon = cleanValues[1];
                    const sucLat = cleanValues[2];
                    const ventanaTiempo = cleanValues[3];
                    const canCajas = cleanValues[4];

                    // Validar que los campos requeridos no estén vacíos
                    if (!sucNom || !sucLon || !sucLat) {
                        console.warn(`Línea ${index + 2} tiene campos requeridos vacíos:`, { sucNom, sucLon, sucLat });
                        return null;
                    }

                    // Función para normalizar nombres para comparación
                    const normalizeName = (name: string) => {
                        return name
                            .toLowerCase()
                            .trim()
                            .replace(/\s+/g, ' ') // Reemplazar múltiples espacios por uno solo
                            .replace(/[.,;:!?]/g, '') // Remover puntuación común
                            .replace(/\s*-\s*/g, '-') // Normalizar guiones
                            .replace(/\s*\.\s*/g, ' '); // Reemplazar puntos con espacios
                    };

                    const normalizedSucNom = normalizeName(sucNom);

                    // Buscar si la sucursal ya existe en branches
                    const existingBranch = branches.find((branch: BranchData) => {
                        if (!branch.name || branch.name.trim() === '') {
                            return false;
                        }

                        const normalizedBranchName = normalizeName(branch.name);

                        // Comparación exacta primero
                        if (normalizedBranchName === normalizedSucNom) {
                            return true;
                        }

                        // Comparación más flexible - verificar si uno contiene al otro
                        // Esto ayuda con variaciones menores
                        return normalizedBranchName.includes(normalizedSucNom) ||
                               normalizedSucNom.includes(normalizedBranchName);
                    });

                    // Debug logging para estos casos específicos
                    if (sucNom.includes('PUNTO 65') || sucNom.includes('PUNTO 556')) {
                        console.log(`🔍 Debug comparación para "${sucNom}":`);
                        console.log(`   Normalizado CSV: "${normalizedSucNom}"`);
                        console.log(`   Sucursal encontrada:`, existingBranch ? `"${existingBranch.name}"` : 'NINGUNA');

                        if (!existingBranch) {
                            console.log(`   Comparando con todas las sucursales existentes:`);
                            branches.slice(0, 10).forEach(branch => { // Solo mostrar las primeras 10 para no saturar
                                if (branch.name && branch.name.toLowerCase().includes('punto')) {
                                    const normalizedBranch = normalizeName(branch.name);
                                    console.log(`     - "${branch.name}" -> "${normalizedBranch}"`);
                                }
                            });
                        }
                    }

                    const result = {
                        linea: index + 2,
                        sucNom: sucNom,
                        sucCallePrincipal: sucNom, // Usar el nombre como dirección por defecto
                        sucLon: parseFloat(sucLon),
                        sucLat: parseFloat(sucLat),
                        ventanaTiempo: ventanaTiempo,
                        canCajas: parseInt(canCajas, 10),
                        existe: !!existingBranch,
                        branchId: existingBranch ? existingBranch.id : null
                    };

                    console.log('Línea ' + result.linea + ': "' + sucNom + '" - ' + (result.existe ? 'EXISTE' : 'NO EXISTE'), existingBranch ? '(ID: ' + existingBranch.id + ')' : '');

                    return result;
                } catch (error) {
                    console.error(`Error procesando línea ${index + 2}:`, line, error);
                    return null;
                }
                });

                // Contar líneas procesadas vs descartadas
                const totalLines = dataLines.length;
                const processedLines = results.filter(r => r !== null).length;
                const discardedLines = totalLines - processedLines;

                console.log(`\n=== Resumen de procesamiento CSV ===`);
                console.log(`Total de líneas en CSV: ${totalLines}`);
                console.log(`Líneas procesadas correctamente: ${processedLines}`);
                console.log(`Líneas descartadas: ${discardedLines}`);
                if (discardedLines > 0) {
                    console.warn(`⚠️  Se descartaron ${discardedLines} líneas. Revisa los warnings anteriores para detalles.`);
                }
                console.log(`===================================\n`);

                const validResults = results.filter((r) => {
                    return r !== null;
                });

                // Resumen
                const existentes = validResults.filter((r) => {
                    return r && r.existe;
                }).length;
                const noExistentes = validResults.filter((r) => {
                    return r && !r.existe;
                }).length;

                console.log('\n=== Resumen ===');
                console.log('Sucursales existentes: ' + existentes);
                console.log('Sucursales NO existentes: ' + noExistentes);
                console.log('===============\n');



                // Mostrar notificación al usuario
                if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addSuccess) {
                    if (noExistentes > 0) {
                        this.props.notification.notification.addSuccess(
                            'CSV procesado exitosamente',
                            'Se encontraron ' + existentes + ' sucursales existentes y ' + noExistentes + ' sucursales nuevas que serán registradas en el sistema.'
                        );
                        // Procesar sucursales nuevas
                        this.processNewBranchesFromCSV(validResults.filter((r) => r && !r.existe));
                    } else {
                        this.props.notification.notification.addSuccess(
                            'CSV procesado exitosamente',
                            'Todas las ' + existentes + ' sucursales del CSV ya existen en el sistema.'
                        );
                    }
                }

                // Aquí puedes guardar los resultados en el estado si lo necesitas para los siguientes pasos
                // this.setState({ csvProcessedData: results });

            } catch (error) {
                console.error('Error al procesar el archivo CSV:', error);
                if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addError) {
                    this.props.notification.notification.addError(
                        'Error al procesar CSV',
                        'Verifique que el archivo tenga el formato correcto'
                    );
                }
            }
        };

        reader.readAsText(file);
    };

    handleDriversFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files ? event.target.files[0] : null;

        if (!file) {
            this.setState({ csvDriversFile: null });
            return;
        }

        this.setState({ csvDriversFile: file });
        this.setState({ csvFleetFile: file });

        // Refrescar la lista de drivers antes de procesar el CSV
        if (this.props.driverActions && this.props.driverActions.actions && this.props.driverActions.actions.fetch) {
            try {
                await this.props.driverActions.actions.fetch();
                console.log('Lista de drivers refrescada desde store');
            } catch (error) {
                console.warn('Error al refrescar lista de drivers desde store:', error);
            }
        }

        // Leer y procesar el archivo CSV
        const reader = new FileReader();
        reader.onload = async (e: any) => {
            try {
                const target = e.target as FileReader;
                const text = target && target.result ? target.result as string : '';
                const lines = text.split('\n');

                // Obtener el arreglo de drivers
                const drivers = this.state.data.drivers || [];
                console.log('Drivers en estado local antes de procesar:', drivers.length);

                // Saltar la primera línea (encabezados)
                const dataLines = lines.slice(1).filter((line) => {
                    return line.trim() !== '';
                });

                console.log('=== Procesando CSV de Choferes ===');
                console.log('Total de líneas en CSV: ' + dataLines.length);
                console.log('Total de drivers existentes: ' + drivers.length);

                // Procesar cada línea del CSV
                const results = dataLines.map((line, index) => {
                    // Parsear la línea CSV de manera más robusta
                    const values = this.parseCSVLine(line);
                    const cleanValues = values.map((v: string) => {
                        return v.replace(/^"|"$/g, '').trim();
                    });

                    if (cleanValues.length < 9) {
                        console.warn('Línea ' + (index + 2) + ' tiene formato incorrecto:', line);
                        return null;
                    }

                    const matricula = cleanValues[0];
                    const capacidad = cleanValues[1];
                    const chofer = cleanValues[2];
                    const marca = cleanValues[3];
                    const modelo = cleanValues[4];
                    const chasis = cleanValues[5];
                    const medidaFurgon = cleanValues[6];
                    const m3 = cleanValues[7];
                    const suc = cleanValues.length >= 9 ? cleanValues[8] : '';

                    // Buscar la sucursal por nombre
                    const branches = this.state.data.branchList || [];
                    const existingBranch = branches.find((branch: BranchData) => {
                        if (!branch.name || branch.name.trim() === '') {
                            return false;
                        }
                        return branch.name.toLowerCase().trim() === suc.toLowerCase().trim();
                    });

                    // Buscar si el chofer ya existe (por nombre o matrícula) en la lista completa de drivers
                    const existingDriver = drivers.find((driver: any) => {
                        if (!driver.user || !driver.user.name) {
                            return false;
                        }
                        return driver.user.name.toLowerCase().trim() === chofer.toLowerCase().trim() ||
                            (driver.registryNumber && driver.registryNumber.toLowerCase().trim() === matricula.toLowerCase().trim());
                    });

                    // También verificar si el chofer ya está seleccionado en el selector
                    const selectedDrivers = this.state.data.drivers && this.state.data.drivers.filter(driver =>
                        this.state.selectedDrivers.includes(driver.id)
                    ) || [];

                    const existingSelectedDriver = selectedDrivers.find((driver: any) => {
                        if (!driver.user || !driver.user.name) {
                            return false;
                        }
                        return driver.user.name.toLowerCase().trim() === chofer.toLowerCase().trim() ||
                            (driver.registryNumber && driver.registryNumber.toLowerCase().trim() === matricula.toLowerCase().trim());
                    });

                    // El chofer existe si está en la lista completa O si está seleccionado
                    const driverExists = !!existingDriver || !!existingSelectedDriver;
                    const driverId = existingDriver ? existingDriver.id : (existingSelectedDriver ? existingSelectedDriver.id : null);

                    const result = {
                        linea: index + 2,
                        matricula: matricula,
                        capacidad: parseFloat(capacidad),
                        chofer: chofer,
                        marca: marca,
                        modelo: modelo,
                        chasis: chasis,
                        medidaFurgon: medidaFurgon,
                        m3: parseFloat(m3),
                        suc: suc,
                        sucursalEncontrada: !!existingBranch,
                        branchId: existingBranch ? existingBranch.id : null,
                        existe: driverExists,
                        driverId: driverId
                    };

                    console.log('Línea ' + result.linea + ': "' + chofer + '" - ' + (result.existe ? 'EXISTE' : 'NO EXISTE'), result.existe ? '(ID: ' + result.driverId + (existingDriver ? ' - En lista completa' : ' - En seleccionados') + ')' : '', '- Sucursal: "' + suc + '" - ' + (result.sucursalEncontrada ? 'ENCONTRADA (ID: ' + result.branchId + ')' : 'NO ENCONTRADA'));

                    return result;
                }).filter((r) => {
                    return r !== null;
                });

                // Resumen
                const existentes = results.filter((r) => {
                    console.log('Revisando existencia para resumen:', r);
                    return r && r.existe;
                }).length;
                const noExistentes = results.filter((r) => {
                    return r && !r.existe;
                }).length;
                const sucursalesEncontradas = results.filter((r) => {
                    return r && r.sucursalEncontrada;
                }).length;
                const sucursalesNoEncontradas = results.filter((r) => {
                    return r && !r.sucursalEncontrada;
                }).length;

                console.log('\n=== Resumen Choferes ===');
                console.log('Choferes existentes: ' + existentes);
                console.log('Choferes NO existentes: ' + noExistentes);
                console.log('Sucursales encontradas: ' + sucursalesEncontradas);
                console.log('Sucursales NO encontradas: ' + sucursalesNoEncontradas);
                console.log('===============\n');

                // Mostrar notificación al usuario
                if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addSuccess) {
                    if (noExistentes > 0) {
                        let mensaje = 'Se encontraron ' + existentes + ' choferes existentes y ' + noExistentes + ' choferes nuevos que serán registrados en el sistema.';
                        if (sucursalesNoEncontradas > 0) {
                            mensaje += ' Advertencia: ' + sucursalesNoEncontradas + ' sucursales no fueron encontradas y se asignarán a la sucursal por defecto.';
                        }
                        this.props.notification.notification.addSuccess(
                            'CSV de choferes procesado exitosamente',
                            mensaje
                        );
                        // Procesar choferes nuevos
                        this.processNewDriversFromCSV(results.filter((r) => r && !r.existe));
                    } else {
                        this.props.notification.notification.addSuccess(
                            'CSV de choferes procesado exitosamente',
                            'Todos los ' + existentes + ' choferes del CSV ya existen en el sistema.'
                        );
                    }
                }

            } catch (error) {
                console.error('Error al procesar el archivo CSV de choferes:', error);
                if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addError) {
                    this.props.notification.notification.addError(
                        'Error al procesar CSV de choferes',
                        'Verifique que el archivo tenga el formato correcto con las columnas: matricula,capacidad,chofer,marca,modelo,chasis,medida_furgon,m3,suc'
                    );
                }
            }
        };

        reader.readAsText(file);
    };

    handleFleetFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files ? event.target.files[0] : null;
        this.setState({ csvFleetFile: file });
    };

    handleFormSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();


        if (!this.state.csvLocationsFile || !this.state.csvFleetFile) {
            this.props.notification.notification.addWarning('Por favor, seleccione ambos archivos CSV antes de enviar el formulario.');
            return;
        }

        this.setState({ isUploading: true });



        try {
            const formData = new FormData();
            formData.append('depot_index', this.state.depotIndex.toString());
            formData.append('service_time', this.state.serviceTime.toString());
            formData.append('demand_unit', this.state.demandUnit);
            formData.append('capacity_unit', this.state.capacityUnit);
            formData.append('box_volume_m3', this.state.boxVolumeM3.toString());
            formData.append('csv_locations_file', this.state.csvLocationsFile);
            formData.append('csv_fleet_file', this.state.csvFleetFile);

           

            const myHeaders = new Headers();
            myHeaders.append("accept", "application/json");

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: formData,
            };

            const response = await fetch("/optimize/csv-to-json/", requestOptions);

            if (!response.ok) {
                if (response.status === 500) {
                    // Limpiar toda la data relacionada con rutas para error 500
                    this.setState({
                        routesData: [],
                        excludedNodes: [],
                        excludedNodesExpanded: false,
                        showRoutesOnMap: false,
                        selectedRouteId: null,
                        routeDirections: {}
                    });
                    throw new Error('Error interno del servidor (500). Se ha limpiado la información de rutas. Por favor, revise los archivos enviados e intente nuevamente.');
                } else {
                    throw new Error(`Error en la petición: ${response.status} ${response.statusText}`);
                }
            }

            const result = await response.json();

            // Procesar la respuesta y transformar al formato esperado
            if (result.routes && Array.isArray(result.routes)) {
                const transformedRoutes = result.routes.map((route: any) => ({
                    vehiculoId: route.vehiculo_id,
                    matricula: route.matricula,
                    driverId: route.matricula ? this.getDriverIdByMatricula(route.matricula) : null,
                    tiempoTotalRutaHhmm: route.tiempoTotalRutaHhmm,
                    kilometrajeTotalRutaKm: route.distanciaTotalRutaKm,
                    cargaTotalRutaCajas: route.cargaTotalRutaCajas,
                    paradas: route.paradas.map((parada: any) => ({
                        secuenciaParada: parada.secuenciaParada,
                        tipoParada: parada.tipoParada,
                        nodoId: parada.nodoId,
                        nombreSucursal: parada.nombreSucursal,
                        branchId: this.getBranchIdByName(parada.nombreSucursal), // ID de sucursal registrada
                        coordenadas: parada.coordenadas,
                        horaLlegada: parada.horaLlegada,
                        horaSalida: parada.horaSalida || null,
                        ventanaTiempo: parada.ventanaTiempo || null,
                        cajasAEntregar: parada.cajasAEntregar
                    }))
                }));

                // Actualizar el estado con las rutas optimizadas y nodos excluidos
                this.setState({
                    routesData: transformedRoutes,
                    excludedNodes: result.excluded_nodes || [],
                    excludedNodesExpanded: false,
                    showRoutesOnMap: true,
                    selectedRouteId: null  // Mostrar todas las rutas por defecto
                });

                this.props.notification.notification.addSuccess(`¡Optimización completada! Se generaron ${transformedRoutes.length} rutas optimizadas.`);
            } else {
                this.props.notification.notification.addError('La respuesta del servidor no tiene el formato esperado.');
            }


        } catch (error) {
            console.error('=== ERROR EN LA PETICIÓN ===');
            console.error('Error:', error);
            this.props.notification.notification.addError(error.message || error);
        } finally {
            this.setState({ isUploading: false });
        }
    };

    // Función helper para mapear nombre de sucursal del WS al ID de sucursal registrada
    getBranchIdByName = (branchName: string): number | null => {
        if (!this.state.data.branchList || !branchName || !branchName.trim()) {
            return null;
        }

        // Buscar sucursal por nombre exacto
        const branch = this.state.data.branchList.find(b =>
            Boolean(b.name && b.name.trim() && b.name.trim().toLowerCase() === branchName.trim().toLowerCase())
        );

        if (branch) {
            return branch.id;
        } else {
            console.warn(`No branch found for name "${branchName}"`);
            return null;
        }
    };

    // Función helper para mapear matrícula del WS al ID de driver registrado
    getDriverIdByMatricula = (matricula: string): number | null => {
        if (!this.state.data.drivers || !matricula || !matricula.trim()) {
            return null;
        }

        // Buscar driver por matrícula (comparación case-insensitive)
        const driver = this.state.data.drivers.find(d =>
            Boolean(d.registryNumber && d.registryNumber.trim().toLowerCase() === matricula.trim().toLowerCase())
        );

        if (driver) {
            return driver.id;
        } else {
            console.warn(`No driver found for matricula "${matricula}"`);
            return null;
        }
    };

    handleRouteSelection = (routeId: number | '') => {
        this.setState({ selectedRouteId: routeId === '' ? null : routeId });
    };

    toggleShowRoutes = () => {
        this.setState(prevState => ({ showRoutesOnMap: !prevState.showRoutesOnMap }));
    };

    toggleMarkersOnly = () => {
        this.setState(prevState => ({
            showMarkersOnly: !prevState.showMarkersOnly,
            // Si activamos solo marcadores, limpiar las rutas cargadas
            routeDirections: prevState.showMarkersOnly ? prevState.routeDirections : {}
        }));
    };

    updateMaxVisibleRoutes = (max: number) => {
        this.setState({ maxVisibleRoutes: max });
    };

    getSelectedRoute = (): Ruta | null => {
        if (!this.state.selectedRouteId || !this.state.routesData.length) { return null };
        return this.state.routesData.find((route: Ruta) => route.vehiculoId === this.state.selectedRouteId) || null;
    };

    getVehicleById = (vehicleId: number): Vehicle | undefined => {
        // Buscar únicamente en los datos reales de drivers/conductores del WebService
        if (this.state.data.drivers && this.state.data.drivers.length > 0) {
            const driver = this.state.data.drivers.find(d => d.id === vehicleId);
            if (driver && driver.vehicle) {
                // Crear un objeto Vehicle a partir de los datos reales del driver
                return {
                    id: driver.id,
                    placa: driver.registryNumber || `VEH-${driver.id}`, // usar número de registro como placa
                    marca: driver.vehicle.brand || 'N/A', // usar marca real del vehículo
                    modelo: driver.vehicle.model || 'N/A', // usar modelo real del vehículo
                    capacidadCajas: Math.round(driver.vehicle.capacidadVolumetrica || 25), // usar capacidad volumétrica
                    conductor: driver,
                    estado: 'ACTIVO' as 'ACTIVO' | 'INACTIVO' | 'MANTENIMIENTO' // asumir activo por defecto
                };
            }
        }

        // No se encontró el vehículo en los datos del WebService
        return undefined;
    };

    openRouteDetailsModal = (route: Ruta) => {
        this.setState({
            showRouteDetailsModal: true,
            selectedRouteForDetails: route
        });
    };

    closeRouteDetailsModal = () => {
        this.setState({
            showRouteDetailsModal: false,
            selectedRouteForDetails: null
        });
    };

    toggleExcludedNodesExpanded = () => {
        this.setState(prevState => ({ excludedNodesExpanded: !prevState.excludedNodesExpanded }));
    };

    handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        this.setState({ selectedTab: newValue });
    };

    handleFormSubmitFromSystem = async () => {
        // Crear el JSON para el enfoque "desde sistema"
        const selectedBranchesData = this.state.data.branchList && this.state.data.branchList.filter(branch =>
            this.state.selectedBranches.includes(branch.id)
        ) || [];

        const selectedDriversData = this.state.data.drivers && this.state.data.drivers.filter(driver =>
            this.state.selectedDrivers.includes(driver.id)
        ) || [];

        if (selectedBranchesData.length === 0 || selectedDriversData.length === 0) {
            this.props.notification.notification.addWarning('Por favor seleccione al menos una sucursal y un conductor');
            return;
        }

        const jsonData = {
            depot_index: this.state.depotIndex,
            service_time: this.state.serviceTime || 10,
            demand_unit: this.state.demandUnit,
            capacity_unit: this.state.capacityUnit,
            box_volume_m3: this.state.boxVolumeM3,
            locations: selectedBranchesData.map((branch, index) => ({
                suc_nom: branch.name,
                suc_lon: branch.location.lng,
                suc_lat: branch.location.lat,
                inicio_ventana: "08:00:00", // Valor por defecto
                fin_ventana: "18:00:00", // Valor por defecto
                demanda: index === this.state.depotIndex ? 0 : (this.state.branchDemands[branch.id] || 10) // Origen tiene demanda 0
            })),
            fleet: selectedDriversData.map((driver, index) => ({
                matricula: driver.user.name, // Usamos el nombre como matrícula
                capacidad: this.state.driverCapacities[driver.id] || 50, // Usar capacidad personalizada o valor por defecto
                driver_id: driver.id // Agregamos el ID del driver para mapeo posterior
            }))
        };



        this.setState({ isUploading: true });

        try {
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("accept", "application/json");

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: JSON.stringify(jsonData),
            };

            const response = await fetch("/optimize/json-to-json/", requestOptions);

            if (!response.ok) {
                if (response.status === 500) {
                    // Limpiar toda la data relacionada con rutas para error 500
                    this.setState({
                        routesData: [],
                        excludedNodes: [],
                        excludedNodesExpanded: false,
                        showRoutesOnMap: false,
                        selectedRouteId: null,
                        routeDirections: {}
                    });
                    throw new Error('Error interno del servidor (500). Se ha limpiado la información de rutas. Por favor, revise los datos enviados e intente nuevamente.');
                } else {
                    throw new Error(`Error en la petición: ${response.status} ${response.statusText}`);
                }
            }

            const result = await response.json();

            // Procesar la respuesta y transformar al formato esperado
            if (result.routes && Array.isArray(result.routes)) {
                const transformedRoutes = result.routes.map((route: any) => ({
                    vehiculoId: route.vehiculo_id,
                    matricula: route.matricula,
                    driverId: route.matricula ? this.getDriverIdByMatricula(route.matricula) : null,
                    tiempoTotalRutaHhmm: route.tiempoTotalRutaHhmm,
                    kilometrajeTotalRutaKm: route.distanciaTotalRutaKm,
                    cargaTotalRutaCajas: route.cargaTotalRutaCajas,
                    paradas: route.paradas.map((parada: any) => ({
                        secuenciaParada: parada.secuenciaParada,
                        tipoParada: parada.tipoParada,
                        nodoId: parada.nodoId,
                        nombreSucursal: parada.nombreSucursal,
                        branchId: this.getBranchIdByName(parada.nombreSucursal), // ID de sucursal registrada
                        coordenadas: parada.coordenadas,
                        horaLlegada: parada.horaLlegada,
                        horaSalida: parada.horaSalida || null,
                        ventanaTiempo: parada.ventanaTiempo || null,
                        cajasAEntregar: parada.cajasAEntregar
                    }))
                }));

                // Actualizar el estado con las rutas optimizadas y nodos excluidos
                this.setState({
                    routesData: transformedRoutes,
                    excludedNodes: result.excluded_nodes || [],
                    excludedNodesExpanded: false,
                    showRoutesOnMap: true,
                    selectedRouteId: null  // Mostrar todas las rutas por defecto
                });

                this.props.notification.notification.addSuccess(`¡Optimización completada desde el sistema! Se generaron ${transformedRoutes.length} rutas optimizadas.`);
            } else {
                this.props.notification.notification.addError('La respuesta del servidor no tiene el formato esperado.');
            }

        } catch (error) {
            console.error('=== ERROR EN LA PETICIÓN (DESDE SISTEMA) ===');
            console.error('Error:', error);
            this.props.notification.notification.addError(error.message || error);
        } finally {
            this.setState({ isUploading: false });
        }
    };

    handleGenerateNewPlanification = () => {
        const excludedNodes = this.state.excludedNodes;
        // const clientLocations = this.state.data.clientLocations || [];

        console.log('Generando CSV de nodos excluidos:', excludedNodes);

        // Función para escapar campos CSV correctamente
        const escapeCSVField = (field: any) => {
            if (field === null || field === undefined){ return ''};
            const stringField = String(field);
            // Si contiene comas, comillas o saltos de línea, envolver en comillas y escapar comillas internas
            if (stringField.includes(',') || stringField.includes('"') || stringField.includes('\n')) {
                return '"' + stringField.replace(/"/g, '""') + '"';
            }
            return stringField;
        };

        // Map excluded nodes with coordinates
        const csvData = excludedNodes.map((node: any) => {
            // const location = clientLocations.find((loc: any) => loc.id === node.nodoId);
            return {
                suc_nom: node.nombreSucursal || '',
                suc_lon: node.Coordenadas ? node.Coordenadas[0] : null,
                suc_lat: node.Coordenadas ? node.Coordenadas[1] : null,
                ventana_tiempo: `"${node.ventanaTiempo || ''}"`,
                demanda: node.cajasAEntregar || 0
            };
        });

        // Create CSV content
        const headers = '"suc_nom","suc_lon","suc_lat","ventana_tiempo","demanda"';

        // Fila estática solicitada que debe ir inmediatamente después del encabezado
        // CENTRAL ACCESO SUR ÑEMBY,-57.5533906,-25.3796875,"00:00:00, 23:59:59",0
        const staticRow = 'CENTRAL ACCESO SUR ÑEMBY,-57.5533906,-25.3796875,"00:00:00, 23:59:59",0';

        const rows = csvData.map(row =>
            `${escapeCSVField(row.suc_nom)},${escapeCSVField(row.suc_lon)},${escapeCSVField(row.suc_lat)},${escapeCSVField(row.ventana_tiempo)},${escapeCSVField(row.demanda)}`
        );

        // Insertar la fila estática como la primera fila de datos (después del encabezado)
        const csvContent = [headers, staticRow, ...rows].join('\n');

        // Download CSV
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', 'excluded_nodes.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    render() {
        const defaultLocation = {
            id: 0, lat: 0, lng: 0, street1: '',
            client: {
                user: { name: '', email: '' },
                phone: ''

            }
        };
        let clientLocations: LocationData[] = [defaultLocation];

        if (this.state.data.clientLocations && this.state.data.clientLocations.length > 0) {
            clientLocations = this.state.data.clientLocations;
            const newLocation = {
                id: 0, lat: 0, lng: 0, street1: '',
                client: {
                    user: {
                        name: clientLocations[0].client.user.name,
                        email: clientLocations[0].client.user.email
                    },
                    phone: clientLocations[0].client.phone
                }
            };
            clientLocations.push(newLocation);

        }


        return (<div>
            {/* Tab Navigation */}
            <Grid container direction="row" style={{ marginBottom: '20px' }}>
                <Grid item md={12}>
                    <Tabs
                        value={this.state.selectedTab}
                        onChange={this.handleTabChange}
                        indicatorColor="primary"
                        textColor="primary"
                    >
                        <Tab label="Procesar por CSV" />
                        <Tab label="Cargar desde Sistema" />
                    </Tabs>
                </Grid>
            </Grid>

            {/* CSV Upload Form - Tab 0 */}
            {this.state.selectedTab === 0 && (
                <Grid container direction="row" style={{ marginBottom: '20px', padding: '20px', border: '1px solid #ccc', borderRadius: '8px' }}>
                    <Grid item md={12}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                            <Typography component="h6">
                                Cargar Datos de Planificación por CSV
                            </Typography>
                            <Button
                                variant="outlined"
                                color="secondary"
                                size="small"
                                onClick={this.handleReset}
                            >
                                🗑️ Limpiar
                            </Button>
                        </div>
                        <form onSubmit={this.handleFormSubmit} encType="multipart/form-data">
                            <Grid container>
                                <Grid item md={3} style={{ paddingRight: '15px' }}>
                                    <TextField
                                        fullWidth
                                        label="Sucursal Origen (Depot Index)"
                                        type="number"
                                        value={this.state.depotIndex}
                                        onChange={this.handleDepotIndexChange}
                                        required
                                        margin="normal"
                                    />
                                </Grid>
                                <Grid item md={3}>
                                    <TextField
                                        fullWidth
                                        label="Tiempo por Sucursal (minutos)"
                                        type="number"
                                        value={this.state.serviceTime ? this.state.serviceTime : 10}
                                        onChange={this.handleServiceTimeChange}
                                        required
                                        margin="normal"
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={16} style={{ marginTop: '10px' }}>
                                <Grid item md={3}>
                                    <Typography style={{ marginTop: '16px', marginBottom: '8px' }}>
                                        Unidad de Demanda
                                    </Typography>
                                    <Select
                                        fullWidth
                                        value={this.state.demandUnit}
                                        onChange={this.handleDemandUnitChange}
                                        displayEmpty
                                        style={{ marginTop: '8px' }}
                                    >
                                        <MenuItem value="cajas">Cajas</MenuItem>
                                        <MenuItem value="volumen">Volumen</MenuItem>
                                    </Select>
                                </Grid>
                                <Grid item md={3}>
                                    <Typography style={{ marginTop: '16px', marginBottom: '8px' }}>
                                        Unidad de Capacidad
                                    </Typography>
                                    <Select
                                        fullWidth
                                        value={this.state.capacityUnit}
                                        onChange={this.handleCapacityUnitChange}
                                        displayEmpty
                                        style={{ marginTop: '8px' }}
                                    >
                                        <MenuItem value="cajas">Cajas</MenuItem>
                                        <MenuItem value="volumen">Volumen</MenuItem>
                                    </Select>
                                </Grid>
                                <Grid item md={3}>
                                    <TextField
                                        fullWidth
                                        label="Volumen por Caja (m³) *"
                                        type="number"
                                        value={this.state.boxVolumeM3.toString()}
                                        onChange={this.handleBoxVolumeChange}
                                        required
                                        margin="normal"
                                        inputProps={{ step: "0.001", min: "0.001" }}
                                        helperText="Campo obligatorio para distribución de vehículos"
                                        error={this.state.boxVolumeM3 <= 0}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={16} style={{ marginTop: '10px' }}>
                                <Grid item md={6} style={{ paddingRight: '15px' }}>
                                    <div style={{ marginTop: '16px' }}>
                                        <input
                                            name="csv-locations-file-upload"
                                            accept=".csv"
                                            style={{ display: 'none' }}
                                            id="csv-locations-file-upload"
                                            type="file"
                                            onChange={this.handleLocationsFileChange}
                                        />
                                        <label htmlFor="csv-locations-file-upload">
                                            <Button
                                                variant="contained"
                                                component="span"
                                                fullWidth
                                                style={{ height: '56px' }}
                                            >
                                                {this.state.csvLocationsFile ? this.state.csvLocationsFile.name : 'Seleccionar archivo CSV de Ubicaciones'}
                                            </Button>
                                        </label>
                                    </div>
                                </Grid>
                                <Grid item md={6}>
                                    <div style={{ marginTop: '16px' }}>
                                        <input
                                            name="csv-fleet-file-upload"
                                            accept=".csv"
                                            style={{ display: 'none' }}
                                            id="csv-fleet-file-upload"
                                            type="file"
                                            onChange={this.handleDriversFileChange}
                                        />
                                        <label htmlFor="csv-fleet-file-upload">
                                            <Button
                                                variant="contained"
                                                component="span"
                                                fullWidth
                                                style={{ height: '56px' }}
                                            >
                                                {this.state.csvDriversFile ? this.state.csvDriversFile.name : 'Seleccionar archivo CSV de Flota'}
                                            </Button>
                                        </label>
                                    </div>
                                </Grid>
                                <Grid item md={12}>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        disabled={this.state.isUploading || !this.isCSVFormValid()}
                                        fullWidth
                                        style={{ marginTop: '10px' }}
                                    >
                                        {this.state.isUploading ? (
                                            <>
                                                <CircularProgress size={20} style={{ marginRight: '10px' }} />
                                                Procesando CSV...
                                            </>
                                        ) : !this.isCSVFormValid() ? (
                                            'Complete todos los campos obligatorios'
                                        ) : (
                                            'Procesar Archivos CSV'
                                        )}
                                    </Button>
                                </Grid>

                                {/* Progress indicator for branch creation */}
                                {this.state.isCreatingBranches && (
                                    <Grid item md={12} style={{ marginTop: '20px' }}>
                                        <Typography variant="body2" style={{ marginBottom: '8px', textAlign: 'center' }}>
                                            Registrando sucursales desde CSV...
                                        </Typography>
                                        <LinearProgress
                                            variant="determinate"
                                            value={this.state.branchesCreationProgress}
                                            style={{ height: '8px', borderRadius: '4px' }}
                                        />
                                        <Typography variant="caption" style={{ marginTop: '4px', textAlign: 'center', display: 'block' }}>
                                            Lote {this.state.currentBatch} de {this.state.totalBatches} - {Math.round(this.state.branchesCreationProgress)}% completado
                                        </Typography>
                                        <Typography variant="caption" style={{ marginTop: '2px', textAlign: 'center', display: 'block' }}>
                                            {this.state.branchesCreated} de {this.state.totalBranchesToCreate} sucursales registradas
                                        </Typography>
                                        {this.props.onCancelBranchCreation && (
                                            <Grid container justify="center" style={{ marginTop: '10px' }}>
                                                <Button
                                                    variant="outlined"
                                                    color="secondary"
                                                    size="small"
                                                    onClick={this.props.onCancelBranchCreation}
                                                    disabled={this.state.isCancellingBranches}
                                                >
                                                    {this.state.isCancellingBranches ? 'Cancelando...' : 'Cancelar Proceso'}
                                                </Button>
                                            </Grid>
                                        )}
                                    </Grid>
                                )}

                                {/* Progress indicator for driver creation */}
                                {this.state.isCreatingDrivers && (
                                    <Grid item md={12} style={{ marginTop: '20px' }}>
                                        <Typography variant="body2" style={{ marginBottom: '8px', textAlign: 'center' }}>
                                            Registrando choferes desde CSV...
                                        </Typography>
                                        <LinearProgress
                                            variant="determinate"
                                            value={(this.state.driversCreated / this.state.totalDriversToCreate) * 100}
                                            style={{ height: '8px', borderRadius: '4px' }}
                                        />
                                        <Typography variant="caption" style={{ marginTop: '4px', textAlign: 'center', display: 'block' }}>
                                            Lote {this.state.currentDriverBatch} de {this.state.totalDriverBatches} - {Math.round((this.state.driversCreated / this.state.totalDriversToCreate) * 100)}% completado
                                        </Typography>
                                        <Typography variant="caption" style={{ marginTop: '2px', textAlign: 'center', display: 'block' }}>
                                            {this.state.driversCreated} de {this.state.totalDriversToCreate} choferes registrados
                                        </Typography>
                                    </Grid>
                                )}
                            </Grid>
                        </form>
                    </Grid>
                </Grid>
            )}

            {/* System Data Form - Tab 1 */}
            {this.state.selectedTab === 1 && (
                <Grid container direction="row" style={{ marginBottom: '20px', padding: '20px', border: '1px solid #ccc', borderRadius: '8px' }}>
                    <Grid item md={12}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                            <Typography component="h6">
                                Cargar Datos desde Sistema
                            </Typography>
                            <Button
                                variant="outlined"
                                color="secondary"
                                size="small"
                                onClick={this.handleReset}
                            >
                                🗑️ Limpiar
                            </Button>
                        </div>
                        <Grid container spacing={16}>
                            <Grid item md={3} style={{ paddingRight: '15px' }}>
                                <TextField
                                    fullWidth
                                    label="Sucursal Origen (Depot Index)"
                                    type="number"
                                    value={this.state.depotIndex}
                                    onChange={this.handleDepotIndexChange}
                                    required
                                    margin="normal"
                                />
                            </Grid>
                            <Grid item md={3}>
                                <TextField
                                    fullWidth
                                    label="Tiempo por Sucursal (minutos)"
                                    type="number"
                                    value={this.state.serviceTime ? this.state.serviceTime : 10}
                                    onChange={this.handleServiceTimeChange}
                                    required
                                    margin="normal"
                                />
                            </Grid>
                            <Grid item md={3}>
                                <Typography style={{ marginTop: '16px', marginBottom: '8px' }}>
                                    Unidad de Demanda
                                </Typography>
                                <Select
                                    fullWidth
                                    value={this.state.demandUnit}
                                    onChange={this.handleDemandUnitChange}
                                    displayEmpty
                                    style={{ marginTop: '8px' }}
                                >
                                    <MenuItem value="cajas">Cajas</MenuItem>
                                    <MenuItem value="volumen">Volumen</MenuItem>
                                </Select>
                            </Grid>
                            <Grid item md={3}>
                                <Typography style={{ marginTop: '16px', marginBottom: '8px' }}>
                                    Unidad de Capacidad
                                </Typography>
                                <Select
                                    fullWidth
                                    value={this.state.capacityUnit}
                                    onChange={this.handleCapacityUnitChange}
                                    displayEmpty
                                    style={{ marginTop: '8px' }}
                                >
                                    <MenuItem value="cajas">Cajas</MenuItem>
                                    <MenuItem value="volumen">Volumen</MenuItem>
                                </Select>
                            </Grid>
                        </Grid>
                        <Grid container spacing={16} style={{ marginTop: '10px' }}>
                            <Grid item md={3}>
                                <TextField
                                    fullWidth
                                    label="Volumen por Caja (m³) *"
                                    type="number"
                                    value={this.state.boxVolumeM3.toString()}
                                    onChange={this.handleBoxVolumeChange}
                                    required
                                    margin="normal"
                                    inputProps={{ step: "0.001", min: "0.001" }}
                                    helperText="Campo obligatorio para distribución de vehículos"
                                    error={this.state.boxVolumeM3 <= 0}
                                />
                            </Grid>
                            <Grid item md={4}>
                                <Typography variant="body2" style={{ marginTop: '16px', marginBottom: '8px', color: '#666' }}>
                                    {'Seleccionar Sucursales'}
                                </Typography>
                                <Select
                                    fullWidth
                                    value={this.state.selectedBranches}
                                    onChange={this.onChangeBranchSelectorMult}
                                    multiple={true}
                                    displayEmpty
                                    style={{ marginTop: '8px' }}
                                >
                                    {this.state.data.branchList && this.state.data.branchList.length > 0 && this.state.data.branchList.map((branch) => (
                                        <MenuItem key={branch.id} value={branch.id}>
                                            {branch.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Grid>
                            <Grid item md={4}>
                                <Typography variant="body2" style={{ marginTop: '16px', marginBottom: '8px', color: '#666' }}>
                                    {'Seleccionar Conductores'}
                                </Typography>
                                <Select
                                    fullWidth
                                    value={this.state.selectedDrivers}
                                    onChange={this.onChangeDriverSelectorMult}
                                    multiple={true}
                                    displayEmpty
                                    style={{ marginTop: '8px' }}
                                >
                                    {this.state.data.drivers && this.state.data.drivers.length > 0 && this.state.data.drivers.map((driver) => (
                                        <MenuItem key={driver.id} value={driver.id}>
                                            {driver.user.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Grid>
                        </Grid>

                        {/* Tabla de demandas para sucursales seleccionadas */}
                        {this.state.selectedBranches.length > 0 && (
                            <Grid container style={{ marginTop: '20px' }}>
                                <Grid item md={12}>
                                    <Typography component="h6" style={{ marginBottom: '15px', color: '#333', fontSize: '1.25rem', fontWeight: 500 }}>
                                        Configurar Demanda por Sucursal
                                    </Typography>
                                    <div style={{ border: '1px solid #ddd', borderRadius: '4px', overflow: 'hidden' }}>
                                        <div style={{ backgroundColor: '#f5f5f5', padding: '12px', borderBottom: '1px solid #ddd' }}>
                                            <Grid container>
                                                <Grid item md={6}>
                                                    <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                                                        Sucursal
                                                    </Typography>
                                                </Grid>
                                                <Grid item md={3}>
                                                    <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                                                        Demanda ({this.state.demandUnit})
                                                    </Typography>
                                                </Grid>
                                                <Grid item md={3}>
                                                    <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                                                        Acciones
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </div>
                                        {this.state.data.branchList && this.state.data.branchList
                                            .filter(branch => this.state.selectedBranches.includes(branch.id))
                                            .map((branch, index) => {
                                                const isOrigin = index === this.state.depotIndex;
                                                return (
                                                    <div key={branch.id} style={{
                                                        padding: '12px',
                                                        borderBottom: index < this.state.selectedBranches.length - 1 ? '1px solid #eee' : 'none',
                                                        backgroundColor: isOrigin ? '#f9f9f9' : 'transparent'
                                                    }}>
                                                        <Grid container alignItems="center">
                                                            <Grid item md={6}>
                                                                <Typography variant="body2" style={{
                                                                    fontWeight: isOrigin ? 'bold' : 'normal',
                                                                    color: isOrigin ? '#1976d2' : 'inherit'
                                                                }}>
                                                                    {branch.name}
                                                                    {isOrigin && (
                                                                        <span style={{
                                                                            fontSize: '0.75rem',
                                                                            marginLeft: '8px',
                                                                            color: '#1976d2',
                                                                            backgroundColor: '#e3f2fd',
                                                                            padding: '2px 6px',
                                                                            borderRadius: '4px'
                                                                        }}>
                                                                            ORIGEN
                                                                        </span>
                                                                    )}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item md={3}>
                                                                <TextField
                                                                    type="number"
                                                                    value={isOrigin ? 0 : (this.state.branchDemands[branch.id] || 10)}
                                                                    onChange={(e) => {
                                                                        if (!isOrigin) {
                                                                            this.handleBranchDemandChange(branch.id, parseInt(e.target.value, 10) || 0)
                                                                        }
                                                                    }}
                                                                    inputProps={{
                                                                        min: 0,
                                                                        step: 1,
                                                                        readOnly: isOrigin
                                                                    }}
                                                                    disabled={isOrigin}
                                                                    fullWidth
                                                                    style={{
                                                                        fontSize: '0.875rem',
                                                                        backgroundColor: isOrigin ? '#f5f5f5' : 'transparent'
                                                                    }}
                                                                />
                                                            </Grid>
                                                            <Grid item md={3}>
                                                                {!isOrigin ? (
                                                                    <Button
                                                                        size="small"
                                                                        onClick={() => this.handleBranchDemandChange(branch.id, 10)}
                                                                        style={{ fontSize: '0.75rem' }}
                                                                    >
                                                                        Resetear
                                                                    </Button>
                                                                ) : (
                                                                    <Typography variant="body2" style={{
                                                                        fontSize: '0.75rem',
                                                                        color: '#666',
                                                                        fontStyle: 'italic'
                                                                    }}>
                                                                        Depósito
                                                                    </Typography>
                                                                )}
                                                            </Grid>
                                                        </Grid>
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>
                                    <Typography variant="body2" style={{ marginTop: '8px', color: '#666', fontStyle: 'italic' }}>
                                        * Modifique los valores de demanda según las necesidades de cada sucursal<br />
                                        * El origen (depósito) siempre tiene demanda 0 y no se puede modificar
                                    </Typography>
                                </Grid>
                            </Grid>
                        )}

                        {/* Tabla de capacidades para conductores seleccionados */}
                        {this.state.selectedDrivers.length > 0 && (
                            <Grid container style={{ marginTop: '20px' }}>
                                <Grid item md={12}>
                                    <Typography component="h6" style={{ marginBottom: '15px', color: '#333', fontSize: '1.25rem', fontWeight: 500 }}>
                                        Configurar Capacidad por Conductor
                                    </Typography>
                                    <div style={{ border: '1px solid #ddd', borderRadius: '4px', overflow: 'hidden' }}>
                                        <div style={{ backgroundColor: '#f5f5f5', padding: '12px', borderBottom: '1px solid #ddd' }}>
                                            <Grid container>
                                                <Grid item md={6}>
                                                    <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                                                        Conductor
                                                    </Typography>
                                                </Grid>
                                                <Grid item md={3}>
                                                    <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                                                        Capacidad ({this.state.capacityUnit})
                                                    </Typography>
                                                </Grid>
                                                <Grid item md={3}>
                                                    <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                                                        Acciones
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </div>
                                        {this.state.data.drivers && this.state.data.drivers
                                            .filter(driver => this.state.selectedDrivers.includes(driver.id))
                                            .map((driver, index) => (
                                                <div key={driver.id} style={{
                                                    padding: '12px',
                                                    borderBottom: index < this.state.selectedDrivers.length - 1 ? '1px solid #eee' : 'none'
                                                }}>
                                                    <Grid container alignItems="center">
                                                        <Grid item md={6}>
                                                            <Typography variant="body2">
                                                                {driver.user.name}
                                                                {driver.vehicle && (
                                                                    <span style={{
                                                                        fontSize: '0.75rem',
                                                                        marginLeft: '8px',
                                                                        color: '#666',
                                                                        backgroundColor: '#f0f0f0',
                                                                        padding: '2px 6px',
                                                                        borderRadius: '4px'
                                                                    }}>
                                                                        {driver.vehicle.brand} {driver.vehicle.model}
                                                                    </span>
                                                                )}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item md={3}>
                                                            <TextField
                                                                type="number"
                                                                value={this.state.driverCapacities[driver.id] || 50}
                                                                onChange={(e) => this.handleDriverCapacityChange(driver.id, parseInt(e.target.value, 10) || 0)}
                                                                inputProps={{ min: 1, step: 1 }}
                                                                fullWidth
                                                                style={{ fontSize: '0.875rem' }}
                                                            />
                                                        </Grid>
                                                        <Grid item md={3}>
                                                            <Button
                                                                size="small"
                                                                onClick={() => this.handleDriverCapacityChange(driver.id, 50)}
                                                                style={{ fontSize: '0.75rem' }}
                                                            >
                                                                Resetear
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                </div>
                                            ))
                                        }
                                    </div>
                                    <Typography variant="body2" style={{ marginTop: '8px', color: '#666', fontStyle: 'italic' }}>
                                        * Ajuste la capacidad de cada conductor según su vehículo asignado
                                    </Typography>
                                </Grid>
                            </Grid>
                        )}

                        <Grid container style={{ marginTop: '20px' }}>
                            <Grid item md={12}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    disabled={this.state.isUploading || !this.isSystemFormValid()}
                                    fullWidth
                                    onClick={this.handleFormSubmitFromSystem}
                                    style={{ marginTop: '10px' }}
                                >
                                    {this.state.isUploading ? (
                                        <>
                                            <CircularProgress size={20} style={{ marginRight: '10px' }} />
                                            Procesando desde Sistema...
                                        </>
                                    ) : !this.isSystemFormValid() ? (
                                        'Complete todos los campos obligatorios'
                                    ) : (
                                        'Procesar Datos del Sistema'
                                    )}
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            )}

            {/* Excluded Nodes Panel */}
            {this.state.excludedNodes && this.state.excludedNodes.length > 0 && (
                <Grid container direction="row" style={{ marginBottom: '20px', padding: '20px', border: '2px solid #f44336', borderRadius: '8px', backgroundColor: '#ffebee' }}>
                    <Grid item md={12}>
                        <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={this.toggleExcludedNodesExpanded}>
                            <Typography component="h6" style={{ marginBottom: '0', color: '#d32f2f', fontWeight: 'bold', flexGrow: 1 }}>
                                🚫 Nodos Excluidos ({this.state.excludedNodes.length}) <Button
                                    onClick={this.handleGenerateNewPlanification}
                                    style={{ marginLeft: '10px', padding: '4px 8px', fontSize: '12px' }}
                                    variant="outlined"
                                    color="primary"
                                >
                                    Exportar a CSV
                                </Button>
                            </Typography>
                            <IconButton style={{ color: '#d32f2f' }}>
                                {this.state.excludedNodesExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            </IconButton>
                        </div>
                        {this.state.excludedNodesExpanded && (
                            <Grid container spacing={16} style={{ marginTop: '15px' }}>
                                {this.state.excludedNodes.map((node: any, index: number) => (
                                    <Grid item md={6} key={index}>
                                        <div style={{ padding: '15px', border: '1px solid #ffcdd2', borderRadius: '4px', backgroundColor: 'white' }}>
                                            <Typography style={{ fontWeight: 'bold', color: '#d32f2f' }}>
                                                {node.nombreSucursal} (ID: {node.nodoId})
                                            </Typography>
                                            <Typography style={{ marginTop: '5px', color: '#666' }}>
                                                <strong>Motivo:</strong> {node.Motivo_Exclusion}
                                            </Typography>
                                            <Typography style={{ color: '#666' }}>
                                                <strong>Cajas:</strong> {node.cajasAEntregar} | <strong>Volumen:</strong> {node.volumenAEntregarM3}m³
                                            </Typography>
                                            <Typography style={{ color: '#666' }}>
                                                <strong>Ventana:</strong> {node.ventanaTiempo}
                                            </Typography>
                                        </div>
                                    </Grid>
                                ))}
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            )}

            {/* Routes Control Panel */}
            {this.state.routesData && this.state.routesData.length > 0 && (
                <Grid container direction="row" style={{ marginBottom: '20px', padding: '20px', border: '1px solid #ccc', borderRadius: '8px' }}>
                    <Grid item md={12}>
                        <Typography component="h6" style={{ marginBottom: '15px' }}>
                            Control de Rutas
                        </Typography>
                        <Grid container spacing={0}>
                            <Grid item md={4} style={{ paddingRight: '15px' }}>
                                <Select
                                    fullWidth
                                    value={this.state.selectedRouteId || ''}
                                    onChange={(e) => this.handleRouteSelection(e.target.value as number | '')}
                                    displayEmpty
                                    style={{ marginTop: '16px' }}
                                >
                                    <MenuItem value="">
                                        <em>Todas las rutas</em>
                                    </MenuItem>
                                    {this.state.routesData.map((route: Ruta) => (
                                        <MenuItem key={route.vehiculoId} value={route.vehiculoId}>
                                            Vehículo {route.vehiculoId} - {route.cargaTotalRutaCajas} cajas
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Grid>
                            <Grid item md={4} style={{ paddingRight: '15px' }}>
                                <Button
                                    variant="contained"
                                    color={this.state.showRoutesOnMap ? "secondary" : "primary"}
                                    onClick={this.toggleShowRoutes}
                                    fullWidth
                                    style={{ marginTop: '16px', height: '56px' }}
                                >
                                    {this.state.showRoutesOnMap ? 'Ocultar Rutas' : 'Mostrar Rutas'}
                                </Button>
                            </Grid>
                            <Grid item md={4}>
                                {(() => {
                                    const selectedRoute = this.getSelectedRoute();
                                    return selectedRoute && (
                                        <div style={{ marginTop: '16px', padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                                            <Typography variant="body2">
                                                <strong>Ruta seleccionada:</strong><br />
                                                {(() => {
                                                    const vehicle = this.getVehicleById(selectedRoute.vehiculoId);
                                                    return vehicle ? (
                                                        <>
                                                            <strong>Vehículo {selectedRoute.vehiculoId}:</strong> {vehicle.marca} {vehicle.modelo} ({vehicle.placa})<br />
                                                            <strong>Tiempo:</strong> {selectedRoute.tiempoTotalRutaHhmm}<br />
                                                            <strong>Distancia:</strong> {selectedRoute.kilometrajeTotalRutaKm} km<br />
                                                            <strong>Carga:</strong> {selectedRoute.cargaTotalRutaCajas} / {vehicle.capacidadCajas} cajas<br />
                                                            <strong>Estado:</strong> {vehicle.estado}
                                                        </>
                                                    ) : (
                                                        <>
                                                            Vehículo: {selectedRoute.vehiculoId}<br />
                                                            Tiempo: {selectedRoute.tiempoTotalRutaHhmm}<br />
                                                            Distancia: {selectedRoute.kilometrajeTotalRutaKm} km<br />
                                                            Cajas: {selectedRoute.cargaTotalRutaCajas}
                                                        </>
                                                    );
                                                })()}
                                            </Typography>
                                        </div>
                                    );
                                })()}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            )}

            {/* Mostrar mapa solo cuando hay rutas optimizadas */}
            {this.state.routesData && this.state.routesData.length > 0 && (
                <React.Fragment>
                    {/* Statistics Panel */}
                    <Grid container  style={{ 
                        marginBottom: '20px', 
                        padding: '20px',
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        borderRadius: '12px',
                        boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)'
                    }}>
                        {/* Total Routes Card */}
                        <Grid item xs={12} md={4}>
                            <div style={{
                                background: 'rgba(255, 255, 255, 0.15)',
                                backdropFilter: 'blur(10px)',
                                borderRadius: '10px',
                                padding: '20px',
                                border: '1px solid rgba(255, 255, 255, 0.18)',
                                textAlign: 'center'
                            }}>
                                <Typography  style={{ color: '#fff', marginBottom: '10px', fontWeight: 300 }}>
                                    Total de Rutas
                                </Typography>
                                <Typography  style={{ color: '#fff', fontWeight: 700 }}>
                                    {this.state.routesData.length}
                                </Typography>
                            </div>
                        </Grid>

                        {/* Total Boxes Card */}
                        <Grid item xs={12} md={4}>
                            <div style={{
                                background: 'rgba(255, 255, 255, 0.15)',
                                backdropFilter: 'blur(10px)',
                                borderRadius: '10px',
                                padding: '20px',
                                border: '1px solid rgba(255, 255, 255, 0.18)',
                                textAlign: 'center'
                            }}>
                                <Typography  style={{ color: '#fff', marginBottom: '10px', fontWeight: 300 }}>
                                    Total de Cajas
                                </Typography>
                                <Typography  style={{ color: '#fff', fontWeight: 700 }}>
                                    {this.state.routesData.reduce((sum, route) => {
                                        const boxes = route.cargaTotalRutaCajas || 0;
                                        return sum + boxes;
                                    }, 0).toLocaleString('es-PY')}
                                </Typography>
                            </div>
                        </Grid>

                        {/* Total Kilometers Card - Highlighted */}
                        <Grid item xs={12} md={4}>
                            <div style={{
                                background: 'rgba(255, 255, 255, 0.95)',
                                backdropFilter: 'blur(10px)',
                                borderRadius: '10px',
                                padding: '20px',
                                border: '3px solid #FFD700',
                                textAlign: 'center',
                                boxShadow: '0 0 20px rgba(255, 215, 0, 0.5)',
                                transform: 'scale(1.05)'
                            }}>
                                <Typography style={{ color: '#667eea', marginBottom: '10px', fontWeight: 600 }}>
                                    Total Kilómetros
                                </Typography>
                                <Typography style={{ color: '#764ba2', fontWeight: 800 }}>
                                    {(() => {
                                        const totalKm = this.state.routesData.reduce((sum, route) => {
                                            const kmValue = route.kilometrajeTotalRutaKm || 0;
                                            return sum + kmValue;
                                        }, 0);
                                        return totalKm.toLocaleString('es-PY', { 
                                            minimumFractionDigits: 2, 
                                            maximumFractionDigits: 2 
                                        });
                                    })()}
                                </Typography>
                                <Typography variant="body2" style={{ color: '#667eea', marginTop: '5px', fontWeight: 500 }}>
                                    km
                                </Typography>
                            </div>
                        </Grid>
                    </Grid>

                    {/* Controles de visualización del mapa */}
                    <Grid container direction="row" style={{ marginBottom: '10px', padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
                        <Grid item md={12}>
                            <Typography style={{ marginBottom: '10px' }}>
                                ⚠️ <strong>Optimización del Mapa</strong> - Con {this.state.routesData.length} rutas
                            </Typography>
                            <div style={{ display: 'flex', gap: '15px', alignItems: 'center', flexWrap: 'wrap' }}>
                                <Button
                                    variant={this.state.showMarkersOnly ? "contained" : "outlined"}
                                    color="primary"
                                    size="small"
                                    onClick={this.toggleMarkersOnly}
                                >
                                    {this.state.showMarkersOnly ? '📍 Solo Marcadores (Rápido)' : '🗺️ Ver Rutas Completas'}
                                </Button>

                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <Typography variant="caption">Rutas simultáneas:</Typography>
                                    <Select
                                        value={this.state.maxVisibleRoutes}
                                        onChange={(e) => this.updateMaxVisibleRoutes(Number(e.target.value))}
                                        style={{ minWidth: '100px', height: '32px' }}
                                    >
                                        <MenuItem value={1}>1 ruta</MenuItem>
                                        <MenuItem value={2}>2 rutas</MenuItem>
                                        <MenuItem value={3}>3 rutas</MenuItem>
                                        <MenuItem value={5}>5 rutas</MenuItem>
                                        <MenuItem value={999}>Todas</MenuItem>
                                    </Select>
                                </div>

                                <Typography variant="caption" color="textSecondary">
                                    💡 Tip: Use "Solo Marcadores" para mejor rendimiento con muchas rutas
                                </Typography>
                            </div>
                        </Grid>
                    </Grid>

                    <Grid container direction="row">
                        <Grid item md={12}>
                            <EnhancedMap
                                center={this.state.center}
                                zoom={this.props.config.maps.startingLocation.zoom}
                                destiny={
                                    this.state.data.visitsDetail &&
                                        this.state.data.visitsDetail.length > 0
                                        ? this.state.data.visitsDetail
                                        : this.state.data.destiny
                                }
                                directions={this.state.data.fullData}
                                handleDragEnd={this.handleDragEnd}
                                handleOnClick={this.handleOnClick}
                                routesData={this.state.routesData}
                                selectedRouteId={this.state.selectedRouteId}
                                showRoutesOnMap={this.state.showRoutesOnMap && !this.state.showMarkersOnly}
                                routeDirections={this.state.routeDirections}
                                onRouteDirectionsChange={(newRouteDirections) => this.setState({ routeDirections: newRouteDirections })}
                                maxVisibleRoutes={this.state.maxVisibleRoutes}
                                showMarkersOnly={this.state.showMarkersOnly}
                            ></EnhancedMap>
                        </Grid>

                        <Grid item md={12}>
                            {this.getRouteDescription()}
                        </Grid>
                    </Grid>

                    <Grid container direction="row">
                        <Grid item md={12}>
                            <hr />
                            <Grid container direction="row" style={{ display: 'flex', alignItems: 'center' }}>
                                <h6>Rutas Disponibles</h6>
                                {/* <Button title="" color="primary" onClick={this.cleanOrder}><ClearAll /> Reasignar orden manualmente</Button>
                        {this.state.confirmarOrdenFlag &&
                            <Button title="" color="primary" onClick={() => this.reorganizateOrder()}><CheckCircleIcon /> Confirmar Orden</Button>
                        }

                        <Button color="primary" onClick={() => this.calculateWaypoints(true)}><LocationSeraching /> Optimizar ruta</Button> */}
                            </Grid>

                            <div style={{ width: '100%' }}>
                                <div>
                                    <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                                        <div style={{ width: '8%' }}><label style={{ fontSize: '13px' }}>Vehículo</label></div>
                                        <div style={{ width: '12%' }}><label style={{ fontSize: '13px' }}>Detalle Vehículo</label></div>
                                        <div style={{ width: '8%' }}><label style={{ fontSize: '13px' }}>Tiempo</label></div>
                                        <div style={{ width: '8%' }}><label style={{ fontSize: '13px' }}>Carga</label></div>
                                        <div style={{ width: '8%' }}><label style={{ fontSize: '13px' }}>Distancia</label></div>
                                        <div style={{ width: '8%' }}><label style={{ fontSize: '13px' }}>Paradas</label></div>
                                        <div style={{ width: '10%' }}><label style={{ fontSize: '13px' }}>Origen</label></div>
                                        <div style={{ width: '10%' }}><label style={{ fontSize: '13px' }}>Destino</label></div>
                                        <div style={{ width: '10%' }}><label style={{ fontSize: '13px' }}>Seleccionar</label></div>
                                        <div style={{ width: '5%' }}><label style={{ fontSize: '13px' }}>Acción</label></div>
                                    </div>
                                </div>
                                <div>
                                    <DragDropContext onDragEnd={() => null}>
                                        <Droppable droppableId="droppable">
                                            {(provided) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.droppableProps}
                                                >
                                                    {this.state.routesData && Array.isArray(this.state.routesData) ? (
                                                        <>
                                                            {this.state.routesData.map((route: Ruta, index: number) => (
                                                                <Draggable key={`${route.vehiculoId}-${index}`} draggableId={`${route.vehiculoId}-${index}`} index={index}>
                                                                    {(prov: any) => (
                                                                        <div
                                                                            ref={prov.innerRef}
                                                                            {...prov.draggableProps}
                                                                            {...prov.dragHandleProps}
                                                                        >
                                                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', fontSize: '11px', border: '1px solid black', borderRadius: '5px' }}>
                                                                                <div style={{ width: '8%', marginLeft: '2px' }}>Vehículo {route.vehiculoId}</div>
                                                                                <div style={{ width: '12%', marginLeft: '2px' }}>
                                                                                    {(() => {
                                                                                        const vehicle = this.getVehicleById(route.vehiculoId);
                                                                                        return vehicle ? (
                                                                                            <div style={{ fontSize: '10px' }}>
                                                                                                <div><strong>{vehicle.marca} {vehicle.modelo}</strong></div>
                                                                                                <div>Placa: {vehicle.placa}</div>
                                                                                                <div>Cap: {vehicle.capacidadCajas} cajas</div>
                                                                                            </div>
                                                                                        ) : 'N/A';
                                                                                    })()}
                                                                                </div>
                                                                                <div style={{ width: '8%', marginLeft: '2px' }}>{route.tiempoTotalRutaHhmm || 'N/A'}</div>
                                                                                <div style={{ width: '8%', marginLeft: '2px' }}>
                                                                                    {route.cargaTotalRutaCajas} cajas
                                                                                </div>
                                                                                <div style={{ width: '8%', marginLeft: '2px', alignItems: 'center', display: 'flex', justifyContent: 'space-around' }}>
                                                                                    {route.kilometrajeTotalRutaKm} km
                                                                                </div>
                                                                                <div style={{ width: '8%', marginLeft: '2px' }}>
                                                                                    {route.paradas ? route.paradas.length : 0} paradas
                                                                                </div>
                                                                                <div style={{ width: '10%', marginLeft: '2px' }}>
                                                                                    {route.paradas && route.paradas.length > 0 ? route.paradas[0].nombreSucursal : 'N/A'}
                                                                                </div>
                                                                                <div style={{ width: '10%', marginLeft: '2px' }}>
                                                                                    {route.paradas && route.paradas.length > 0 ? route.paradas[route.paradas.length - 1].nombreSucursal : 'N/A'}
                                                                                </div>
                                                                                <div style={{ width: '10%', marginLeft: '2px' }}>
                                                                                    <IconButton
                                                                                        aria-label="Seleccionar"
                                                                                        title="Seleccionar ruta"
                                                                                        onClick={() => this.handleRouteSelection(route.vehiculoId)}
                                                                                    >
                                                                                        <CheckCircleIcon />
                                                                                    </IconButton>
                                                                                </div>
                                                                                <div style={{ width: '5%', marginLeft: '2px' }}>
                                                                                    <div style={{ display: 'flex', gap: '4px' }}>

                                                                                        <Button
                                                                                            variant="outlined"
                                                                                            size="small"
                                                                                            onClick={() => this.openRouteDetailsModal(route)}
                                                                                            style={{ fontSize: '10px', padding: '2px 6px' }}
                                                                                        >
                                                                                            Ver Detalles
                                                                                        </Button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </Draggable>
                                                            ))}
                                                            {provided.placeholder}
                                                        </>
                                                    ) : (
                                                        <CircularProgress />
                                                    )}
                                                </div>
                                            )}
                                        </Droppable>
                                    </DragDropContext>
                                </div>
                            </div>
                            <br />

                            {/* Barra de progreso para creación de carreras */}
                            {this.state.isCreatingRaces && (
                                <div style={{ marginBottom: 16 }}>
                                    <Typography variant="body2" gutterBottom>
                                        Creando planificación: {this.state.racesCreated} de {this.state.totalRacesToCreate}
                                    </Typography>
                                    <LinearProgress
                                        variant="determinate"
                                        value={this.state.racesCreationProgress}
                                        style={{ marginBottom: 8 }}
                                    />
                                </div>
                            )}

                            {/* Mostrar botón guardar solo cuando hay rutas optimizadas */}
                            <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={this.handleSubmit}
                                    disabled={this.state.isCreatingRaces}
                                >
                                    {this.state.isCreatingRaces ? 'Creando...' : 'Guardar'}
                                </Button>
                                <Button
                                    onClick={this.handleCancel}
                                > Cancelar </Button>
                            </div>
                        </Grid>
                    </Grid>
                </React.Fragment>
            )}

            {/* Modal for Route Details */}
            <Dialog
                open={this.state.showRouteDetailsModal}
                onClose={this.closeRouteDetailsModal}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>
                    Detalles de la Ruta - Vehículo {this.state.selectedRouteForDetails && this.state.selectedRouteForDetails.vehiculoId ? this.state.selectedRouteForDetails.vehiculoId : ''}
                </DialogTitle>
                <DialogContent>
                    {this.state.selectedRouteForDetails && (
                        <div>
                            {/* Vehicle Information */}
                            <Typography component="h6" style={{ marginBottom: '10px' }}>
                                Información del Vehículo
                            </Typography>
                            {(() => {
                                const vehicle = this.getVehicleById(this.state.selectedRouteForDetails.vehiculoId);
                                return vehicle ? (
                                    <Grid container style={{ marginBottom: '20px' }}>
                                        <Grid item xs={6}>
                                            <Typography><strong>Marca:</strong> {vehicle.marca}</Typography>
                                            <Typography><strong>Modelo:</strong> {vehicle.modelo}</Typography>
                                            <Typography><strong>Placa:</strong> {vehicle.placa}</Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography><strong>Capacidad:</strong> {vehicle.capacidadCajas} cajas</Typography>
                                            <Typography><strong>Estado:</strong> {vehicle.estado}</Typography>
                                            {vehicle.conductor && (
                                                <Typography><strong>Conductor:</strong> {vehicle.conductor.user.name}</Typography>
                                            )}
                                        </Grid>
                                    </Grid>
                                ) : (
                                    <Typography>No se encontró información del vehículo</Typography>
                                );
                            })()}

                            {/* Route Summary */}
                            <Typography component="h6" style={{ marginBottom: '10px' }}>
                                Resumen de la Ruta
                            </Typography>
                            <Grid container style={{ marginBottom: '20px' }}>
                                <Grid item xs={4}>
                                    <Typography><strong>Tiempo Total:</strong> {this.state.selectedRouteForDetails.tiempoTotalRutaHhmm}</Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography><strong>Distancia Total:</strong> {this.state.selectedRouteForDetails.kilometrajeTotalRutaKm} km</Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography><strong>Carga Total:</strong> {this.state.selectedRouteForDetails.cargaTotalRutaCajas} cajas</Typography>
                                </Grid>
                            </Grid>

                            {/* Stops Details */}
                            <Typography component="h6" style={{ marginBottom: '10px' }}>
                                Detalles de las Paradas
                            </Typography>
                            {this.state.selectedRouteForDetails.paradas && this.state.selectedRouteForDetails.paradas.length > 0 ? (
                                <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                    {this.state.selectedRouteForDetails.paradas.map((parada, index) => (
                                        <div key={index} style={{ border: '1px solid #ddd', borderRadius: '4px', padding: '10px', marginBottom: '10px' }}>
                                            <Typography style={{ fontWeight: 'bold' }}>
                                                Parada {index + 1}: {parada.nombreSucursal}
                                            </Typography>
                                            <Grid container>
                                                <Grid item xs={6}>
                                                    <Typography><strong>Tipo:</strong> {parada.tipoParada}</Typography>
                                                    <Typography><strong>Cajas a entregar:</strong> {parada.cajasAEntregar}</Typography>
                                                    <Typography><strong>Hora llegada:</strong> {parada.horaLlegada}</Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Typography><strong>Coordenadas:</strong> {parada.coordenadas[1]}, {parada.coordenadas[0]}</Typography>
                                                    <Typography><strong>Secuencia:</strong> {parada.secuenciaParada}</Typography>
                                                    {parada.horaSalida && (
                                                        <Typography><strong>Hora salida:</strong> {parada.horaSalida}</Typography>
                                                    )}
                                                </Grid>
                                            </Grid>
                                            {parada.ventanaTiempo && (
                                                <Typography style={{ marginTop: '8px' }}>
                                                    <strong>Ventana de tiempo:</strong> {parada.ventanaTiempo}
                                                </Typography>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <Typography>No hay paradas disponibles para esta ruta</Typography>
                            )}
                        </div>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.closeRouteDetailsModal} color="primary">
                        Cerrar
                    </Button>
                </DialogActions>
            </Dialog>

        </div>);
    }

}


export default compose<any, PlanificacionSelectorProps>(withProps((props: PlanificacionSelectorProps) => {
    return {
        googleMapURL: `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${props.config.maps.key}`,
        loadingElement: <div style={{ height: '400px' }} />,
    }
}), withScriptjs)(PlanificacionSelector);



// WEBPACK FOOTER //
// ./src/components/planificacion/planificacionSelector.tsx